import { Component, OnInit, ViewChild,ViewEncapsulation, TemplateRef } from '@angular/core';
import { FormArray,FormGroup,FormControl, Validators } from '@angular/forms';
import { ModalDirective,BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { LoadService } from '../../services/load.service';
import { LocationService } from '../../services/location.service';
import { PackingEcService } from '../../services/packingec.service';
import { PalletsService } from '../../services/pallets.service';
import { TagsService } from '../../services/tags.service';
import { StockService } from '../../services/stock.service';
import { BsDatepickerConfig, BsLocaleService } from 'ngx-bootstrap/datepicker';
import { listLocales } from 'ngx-bootstrap/chronos';
import { debounceTime } from 'rxjs/operators/debounceTime';
import * as $ from 'jquery';

@Component({
selector: 'movimientos',
templateUrl: './movimientos.component.html',
styleUrls: ['./movimientos.component.css'],
encapsulation: ViewEncapsulation.None
})
export class MovimientosComponent implements OnInit {
  @ViewChild(ModalDirective) public lgModal: ModalDirective;
  public modalRef: BsModalRef;
  public load:number;
  public myAngularxQrCode: string;
  public primeracarga:boolean;
  public isopen:boolean;
  public alert:string;
  public data_list:any;
  public links: any;
  public meta: any;
  public title:string;
  public isNew:boolean;
  public signupForm:FormGroup;
  public signupForm2:FormGroup;
  public signupForm3:FormGroup;
  public signupForm4:FormGroup;
  public signupFormMov0:FormGroup;
  public signupFormMov1:FormGroup;
  public signupFormMov2:FormGroup;
  public signupFormMov3:FormGroup;
  public signupFormMov3b:FormGroup;
  public signupFormSal0:FormGroup;
  public signupFormSal1:FormGroup;
  public signupFormBuscar:FormGroup;
  public signupFormCuadrarPallet:FormGroup;
  public cajas:any[];
  public pallets:any[];
  public tarea:boolean;
  public buscar:boolean;
  public entrada:boolean;
  public movimiento:boolean;
  public salida:boolean;
  public title2:string;
  public title3:string;
  public locaciones:any[];
  public packings:any[];
  public tags:any[];
  public contadortags:number;
  public palletsconcajas: any[];
  public ubicacionesconcajas: any[];
  public posiciones: any[];
  public palletacompletar: number;
  public ubicacionacompletar: number;
  public etapa:number;
  public etapamov:number;
  public etapasal:number;
  public cajas2:any[];
  public pallets2:any[];
  public cajas3:any[];
  public pallets3:any[];
  public positions:any[];
  public salidas:any[];
  public palletubicados:any[];
  public paso1:boolean;
  public paso2:boolean;
  public paso1mov:boolean;
  public paso2mov:boolean;
  public paso3mov:boolean;
  public paso4mov:boolean;
  public op:any[];
  public palletencontrado:boolean;
  public posicionesvacias:any[];
  public palletsnuevos:any[];
  public posicionespalletsvacios:any[];
  public ispalletnuevo:boolean;
  public palletsaeliminar:any[];
  public packingpallet:any[];

  /*propiedades a mostrar cuando se busca un pallet*/
  public ubicacion_Pallet:string;
  public posicion_Pallet:string;
  public op_pallet:string;
  public cajas_pallet:number;
  public comentarios:any[];
  /*propiedades a mostrar cuando se busca un pallet*/

  public corregir:boolean;
  public namepackingpallet:string;
  public newpackingpallet:any[];
  public trabajando :boolean;
  public cajasaeliminar: any[];
  public buscarcaja: any[];
  public track_caja: any[];
  public debtime:number;
  public tipoCaja:string;
  public tagsUnion:any[];
  public isgeneric:boolean;
  public isgeneric_movimiento:boolean;
  public code:string;
  public codeCaja:string;
  public codePallet:string;
  public codeSalida:string;
  public comenzarSalida:boolean;

  /*cajas y pallets no encontradas*/
  public boxes_not_found:any[];
  public pallets_not_found:any[];

  constructor(private _stockService:StockService,private _palletsService:PalletsService,private _tagsService:TagsService,private _packingecService:PackingEcService,private _locationService:LocationService,private _localeService: BsLocaleService,private _loaddata: LoadService,   private modalService: BsModalService) {
    this.isopen = false;
    this.alert = "";
    this.primeracarga = false;
    this.myAngularxQrCode = ' ';
    this.tarea = false;
    this.buscar = false;
    this.entrada = false;
    this.movimiento = false;
    this.salida = false;
    this.title2 = "";
    this.title3 = "";
    this.contadortags = 0;
    this.locaciones = [];
    this.packings =[];
    this.tags = [];
    this.palletsconcajas = [];
    this.ubicacionesconcajas = [];
    this.cajas = [];
    this.pallets = [];
    this.posiciones = [];
    this.palletacompletar = -1;
    this.ubicacionacompletar = -1;
    this.etapa = 1;
    this.cajas2 = [];
    this.pallets2 = [];
    this.cajas3 = [];
    this.pallets3 = [];
    this.positions = [];
    this.etapamov = 1;
    this.etapasal = 1;
    this.salidas = [];
    this.palletubicados = [];
    this.paso1 = false;
    this.paso2 = false;
    this.paso1mov = false;
    this.paso2mov = false;
    this.paso3mov = false;
    this.paso4mov = false;
    this.op = [];
    this.palletencontrado = false;
    this.posicionesvacias = [];
    this.palletsnuevos = [];
    this.posicionespalletsvacios = [];
    this.ispalletnuevo = false;
    this.palletsaeliminar = [];
    this.packingpallet = [];
    this.ubicacion_Pallet = '';
    this.posicion_Pallet = '';
    this.op_pallet = '';
    this.cajas_pallet = 0;
    this.corregir = false;
    this.namepackingpallet = '';
    this.newpackingpallet = [];
    this.trabajando = false;
    this.buscarcaja = [];
    this.track_caja = [];
    this.debtime = 60000;
    this.tipoCaja = '';
    this.tagsUnion = [];
    this.comentarios = [];
    this.isgeneric = false;
    this.isgeneric_movimiento = false;
    this.code = 'Pistolee una Caja o Pallet';
    this.codeCaja = 'Pistolee las Cajas a Mover';
    this.codePallet = 'Pistolee el Pallet';
    this.codeSalida = 'Pistolee Cajas o Pallets';
    this.comenzarSalida = false;

    this.boxes_not_found = [];
    this.pallets_not_found = [];

    $(document).keypress((e)=> {


          if(this.buscar == true){
            // console.log("esta en buscar");
            //obteniendo el valor actual;
            // let codigo = this.signupFormBuscar.get('busqueda').value;
            //let bla = $('#inputBuscar').val();
            // codigo+=e.key;
            //Seteando el valor del input
            //$('#inputBuscar').val(bla);
            // this.signupFormBuscar.setValue({
            //   'busqueda':codigo
            // });
            //console.log(e.key);
            //si presiona enter
            // if (e.which == 13) {
            //      console.log("COD:",this.signupFormBuscar.get('busqueda').value);
                 // Se presionó la tecla enter
                 //let code = $('#inputBuscar').val();
                //  let code = this.signupFormBuscar.get('busqueda').value;
                //  //seteando el campo de busqueda
                //  // this.signupFormBuscar.setValue({
                //  //   'busqueda': code
                //  // });
                //
                //  //dejando en vacio el valor del input
                //  //$('#inputBuscar').val('');
                // // this.signupFormBuscar.setValue({
                // //   'busqueda':''
                // // });
                //  //this.code = code;
                //  // don't submit the form
                //  //e.preventDefault();
                //  console.log("presiono enter");
                //  this.onSearchNew(code);
             // }
          }
          else if(this.movimiento==true && this.etapamov == 3){
            //console.log("esta en movimiento de caja");
            //obteniendo el valor actual;
            //var bla = $('#codeCaja').val();

            let codigo = this.signupFormMov1.get('busqueda').value;
            codigo+=e.key;
            //Seteando el valor del input
            //$('#codeCaja').val(bla);
            this.signupFormMov1.setValue({
              'busqueda':codigo
            });

            if (e.which == 13) {
                 // Se presionó la tecla enter
                 //let code = $('#codeCaja').val();
                 //seteando el campo de busqueda
                 // this.signupFormMov1.setValue({
                 //   'busqueda': code
                 // });
                let code = this.signupFormMov1.get('busqueda').value;
                 //dejando en vacio el valor del input
                 //$('#codeCaja').val('');

                 //this.code = code;
                 // don't submit the form
                 //e.preventDefault();
                 //console.log("presiono enter - codigo recibido seccion mover caja: ",code);
                 this.onCheckTagMovCajaNew(code);
             }
          }
          else if(this.movimiento==true && this.etapamov == 2){
            //console.log("esta en movimiento de Pallet");

            let codigo = this.signupFormMov0.get('busqueda').value;
            codigo+=e.key;
            //Seteando el valor del input
            //$('#codeCaja').val(bla);
            this.signupFormMov0.setValue({
              'busqueda':codigo
            });

            if (e.which == 13) {
                 // Se presionó la tecla enter
                let code = this.signupFormMov0.get('busqueda').value;
                //console.log("presiono enter - codigo recibido seccion mover pallet: ",code);
                 this.onCheckTagMovPalletNew(code);
             }
          }
          else if(this.salida && this.etapasal == 1){
            //console.log("esta en salida de cajas y pallet");
            let codigo = this.signupFormSal0.get('busqueda').value;
            codigo+=e.key;
            this.signupFormSal0.setValue({
              'busqueda':codigo
            });

            if (e.which == 13) {
                 // Se presionó la tecla enter
                let code = this.signupFormSal0.get('busqueda').value;
                //console.log("presiono enter - codigo recibido seccion Salida cajas y pallet: ",code);
                 this.onCheckTagSalNew(code);
             }
          }



    });
  }

  ngOnInit() {

    this._loaddata.loadChange(10);
    this._localeService.use('es');
    this._loaddata.loadCurrent.subscribe(a=> this.load = a);
    this.signupForm = new FormGroup({
      'busqueda': new FormControl("",Validators.required)
    });

    this.signupForm2 = new FormGroup({
      'busqueda': new FormControl("",Validators.required)
    });
    this.signupForm3 = new FormGroup({
      'pallet': new FormControl("",Validators.required),
      'ubicacion': new FormControl("",Validators.required),
      'busqueda':new FormControl(null)
    });

    this.signupForm3.get('busqueda').valueChanges.pipe(debounceTime(this.debtime)).subscribe(text => this.onDeleteText(1));

    this.signupForm4 = new FormGroup({
      'palletsnuevos':new FormArray([])
    });
    this.signupFormBuscar = new FormGroup({
      'busqueda': new FormControl(''),
    });
    //this.signupFormBuscar.disable();
    /*this.signupFormBuscar.get('busqueda').valueChanges.pipe(debounceTime(this.debtime)).subscribe(text => this.onDeleteText(2));*/

    this.signupFormCuadrarPallet = new FormGroup({
      'busqueda': new FormControl(""),
    });
    this.signupFormMov0 = new FormGroup({
      'busqueda': new FormControl("",Validators.required)
    });

    this.signupFormMov0.get('busqueda').valueChanges.pipe(debounceTime(this.debtime)).subscribe(text => this.onDeleteText(3));

    this.signupFormMov1 = new FormGroup({
      'busqueda': new FormControl("",Validators.required)
    });

    this.signupFormMov1.get('busqueda').valueChanges.pipe(debounceTime(this.debtime)).subscribe(text => this.onDeleteText(4));

    this.signupFormMov2 = new FormGroup({
      'pallets':new FormArray([])
    });
    this.signupFormMov3 = new FormGroup({
      'cajas':new FormArray([])
    });

    this.signupFormMov3b = new FormGroup({
      'idubicacion': new FormControl(null,Validators.required),
      'idpallet': new FormControl(null),
      'idposicion': new FormControl(null),
      'ubicacion':new FormControl(null),
      'pallet': new FormControl(null),
      'posicion': new FormControl(null),
      'guia':new FormControl(null,Validators.required)
    });

    this.signupFormSal0 = new FormGroup({
      'busqueda': new FormControl("",Validators.required)
    });

    this.signupFormSal0.get('busqueda').valueChanges.pipe(debounceTime(this.debtime)).subscribe(text => this.onDeleteText(5));

    this.signupFormSal1 = new FormGroup({
      'idsalida': new FormControl("",Validators.required),
      'nombresalida': new FormControl("",Validators.required),
      'guiadespacho':new FormControl("",Validators.required),
      'salida':new FormControl(null),
      'cliente':new FormControl(null)
    });

    this.loadSalidas();
  }

  loadSalidas():void{
    this.alert = "Cargando motivos de salidas.";
    this.isopen = true;
    this._loaddata.loadChange(40);

    this._stockService.getStockExitReasons().subscribe(
      (response:any) => {

        let op = false;
        for(let razon of response.data){
          if(razon.id != 15){
            if(razon.id == 8 || razon.id == 9){
              op = true;
            }
            else{
              op = false;
            }
            this.salidas = [...this.salidas,{'id':razon.id,'name':razon.attributes.name,'op':op}];
          }
        }

        this.loadLocaciones();
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  /**
  * carga el listado de todas las ubicaciones
  */
  loadLocaciones():void{
    this.alert = "Cargando ubicaciones."
    this.isopen = true;
    this._loaddata.loadChange(50);
    this._locationService.get().subscribe(
      (response:any) => {
        //console.log("locaciones", response);
        this.locaciones = response.data;
        this._locationService.emptyPositionsFromAllLocations().subscribe((response:any) => {
          //console.log("respuesta", response);
          for(let pos of response.data){
            this.posicionesvacias.push({idubicacion:pos.relationships.location.data.id,idposicion:pos.id})
          }
          this.loadData();
        },
        (error) => {
          this.showError(error.error.error);
        });
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  /**
  * Carga el menu de movimientos
  */
  loadData():void{
    this._loaddata.loadChange(100);
    this.alert = "Carga Correcta."
    this.isopen = true;
    this.onClosedAutomatic();
    if(this.primeracarga === false){
      this.primeracarga = !this.primeracarga;
    }
  }

  onBuscar():void{
    this.buscar = true;
    this.entrada = false;
    this.movimiento = false;
    this.salida = false;
    this.corregir = false;
    this.comenzarSalida = false;
  }

  onPaste(op){
    let that = this;

    if(op == 1){
      setTimeout(function(){
        that.signupFormBuscar.reset();
        that.signupFormBuscar.patchValue({
          'busqueda': ''
        });
      },1);
    }
    else if(op == 2){
      setTimeout(function(){
        that.signupForm2.reset();
        that.signupForm2.patchValue({
          'busqueda': ''
        });
      },1);
    }
    else if(op == 3){
      setTimeout(function(){
        that.signupForm3.reset();
        that.signupForm3.patchValue({
          'busqueda': ''
        });
      },1);
    }
    else if(op == 4){
      setTimeout(function(){
        that.signupFormMov0.reset();
        that.signupFormMov0.patchValue({
          'busqueda': ''
        });
      },1);
    }
    else if(op == 5){
      //console.log("INGRESO ACÁ");
      setTimeout(function(){
        that.signupFormMov1.reset();
        that.signupFormMov1.patchValue({
          'busqueda': ''
        });
      },1);
    }
    else if(op == 6){
      setTimeout(function(){
        that.signupFormSal0.reset();
        that.signupFormSal0.patchValue({
          'busqueda': ''
        });
      },1);
    }
  }

  onDeleteText(op){
    if(op == 1){
      this.signupForm3.reset();
      this.signupForm3.patchValue({
        'busqueda': ''
      });
    }
    else if(op == 2){
      this.signupFormBuscar.reset();
      this.signupFormBuscar.patchValue({
        'busqueda': ''
      });
    }
    else if(op == 3){
      this.signupFormMov0.reset();
      this.signupFormMov0.patchValue({
        'busqueda': ''
      });
    }
    else if(op == 4){
      this.signupFormMov1.reset();
      this.signupFormMov1.patchValue({
        'busqueda': ''
      });
    }
    else if(op == 5){
      this.signupFormSal0.reset();
      this.signupFormSal0.patchValue({
        'busqueda': ''
      });
    }
  }

  onSearchNew(q){
    //console.log("Funcion onSearchNew");
    //let qr = this.signupFormBuscar.get('busqueda').value;
    let qr = q;
    //console.log("QR RECIBIDO: ",qr);
    /*quitar la palabra enter*/
     // if(qr.includes('Enter')){
     //   let separar = qr.split('Enter');
     //   qr = separar[0];
     //   qr = 'P18-0000-112-';
     // }
    /*reseteando el formulario*/
    this.signupFormBuscar.reset();
    this.signupFormBuscar.patchValue({
      'busqueda': ''
    });

    this.tipoCaja = '';
    if(qr != null && qr != ''){
      this.buscarcaja = [];
      this.packingpallet = [];
      this.newpackingpallet = [];
      this.namepackingpallet = '';
      this.alert = "Realizando busqueda.";
      this.isopen = true;
      this._loaddata.loadChange(20);
      let variable = '';
      let guion = 0;
      let prefijopallet = '';
      let sufijocaja = '';
      let prefijo = 0;
      let sufijo = 0;

      /*Derrepente la pistola lee 3 caracteres raros*/
      if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
        qr = qr.substring(3);
      }
      //comprobando si es un pallet al pistolear entrega el formato P18'0000'112Enter
      let regexp2 = new RegExp("^P\\d{2}[']\\d{4}['][0-9]{1,4}");
      if(regexp2.test(qr)){
        //console.log("PALLET",qr);
        let separar = qr.split("'");
        qr = `${separar[0]}-${separar[1]}-${separar[2]}-`;
      }
      // else{
      //   console.log("Es una caja",qr.length);
      // }
      /*P18-0000-131-*/
      let regexp = new RegExp('P\\d{2}-\\d{4}-[0-9]{1,4}-');
      //console.log("QR ANTES DEL REGEXP:",qr);
      if(regexp.test(qr)){
        for(var char of qr){
          if(char != '-'){
            variable += char
          }
          else if(guion == 0){
            variable += '-';
            guion = 1;
          }
          else if(guion == 1){
            prefijopallet = variable;
            variable = '';
            guion = 2;
          }
          else if (guion == 2){
            sufijocaja = variable;
            variable = '';
            guion = 3
          }
        }

        this.code = `${prefijopallet}-${sufijocaja}`;

        this._palletsService.getOneByNumber(prefijopallet+'-'+sufijocaja).subscribe(
          (response:any) => {
            //console.log("respuesta del pallet: ", response);
            if(response.data.length == 0){
              this.alert = "No existe el pallet "+prefijopallet+'-'+sufijocaja+" en el sistema.";
              this.isopen = true;
              this._loaddata.loadChange(100);
            }
            else{
              this.alert = "Pallet "+prefijopallet+"-"+sufijocaja+" encontrado. Generando packing pallet.";
              this.isopen = true;
              this._loaddata.loadChange(50);
              this.namepackingpallet = response.data[0].attributes.number;
              this.cajas_pallet = response.data[0].attributes.amount;
              if(response.data[0].relationships.position.data != null){
                this.ubicacion_Pallet = response.data[0].relationships.position.data.attributes.location;
                this.posicion_Pallet = response.data[0].relationships.position.data.attributes.name;
              }
              else{
                this.ubicacion_Pallet = 'Sin Ubicación';
                this.posicion_Pallet = 'Sin Posición';
              }
              this.detallePallet(response.data[0].id);
              //this.generatePackingPallet(response.data[0].id);
            }
          },
          (error) => {
            this.showError(error.error.error);
          }
        );
      }
      else{
        //console.log("Entro a la caja: ",)
        for(let char of qr){
          if(char != '-'){
            variable += char
          }
          else if(guion == 0){
            prefijo = parseInt(variable);
            variable = '';
            guion = 1;
          }
          else if(guion == 1){
            sufijo = parseInt(variable);
            variable = '';
            guion = 2;
          }
        }

        this.signupFormBuscar.reset();
        this.signupFormBuscar.patchValue({
          'busqueda': ''
        });
        this.code = `${prefijo}-${sufijo}`;
        if(sufijo > 0 && sufijo < 92 && prefijo > 0 &&  isNaN(sufijo) == false && isNaN(prefijo) == false){
          this._stockService.getOneStock(prefijo.toString(),sufijo.toString()).subscribe(
            (response:any) => {
              //console.log("Respuesta Busqueda Codigo caja: ", response.relationships.tag.data.attributes.suffix);
              let tipo = parseInt(response.relationships.tag.data.relationships.box_type.data.id);
              let tag_id = parseInt(response.attributes.tag_id);
              let peso = 0;
              let packing = 'Sin información.';
              let qr = 'Sin información';

              if(tipo === 1){
                this.tipoCaja = 'NORMAL';
              }
              else if(tipo === 2){
                this.tipoCaja = 'SALDO';
              }
              else if(tipo === 3){
                this.tipoCaja = 'UNION DE SALDO';
              }

              if(response.relationships.tag.data.attributes.code != null && response.relationships.tag.data.attributes.code != ''){
                qr = response.relationships.tag.data.attributes.code;
              }

              if(response.relationships.tag.data.relationships.packing.data != null){
                packing = response.relationships.tag.data.relationships.packing.data.id;
              }

              if(parseInt(response.relationships.tag.data.attributes.residue) != 0){
                peso = parseInt(response.relationships.tag.data.attributes.residue);
              }
              else{
                peso = parseInt(response.relationships.tag.data.relationships.product.data.relationships.properties.data[9].attributes.name);
              }
              this.buscarcaja.push({
                'id':response.id,
                'peso':peso,
                'estadotag':response.relationships.tag.data.relationships.tag_status.data.attributes.name,
                'cliente':response.relationships.tag.data.relationships.production_order.data.attributes.client,
                'ordenproduccion':response.relationships.tag.data.relationships.production_order.data.attributes.number,
                'descripcion':response.relationships.tag.data.relationships.product.data.attributes.description,
                'grupo':response.relationships.tag.data.relationships.product.data.attributes.group,
                'producto':response.relationships.tag.data.relationships.product.data.attributes.code,
                'packing':packing,
                'lote':response.relationships.tag.data.relationships.lot.data.attributes.code,
                'tipotag':response.relationships.tag.data.relationships.box_type.data.name,
                'estadostock':response.relationships.status.data.attributes.name,
                'cantidad':response.relationships.pallet.data.attributes.amount,
                'pallet':response.relationships.pallet.data.attributes.number,
                'observacion':response.attributes.observation,
                'elaboracion':response.relationships.tag.data.attributes.elaboration_date,
                'vencimiento':response.relationships.tag.data.attributes.expiration_date,
                'qr':qr,
                'sufijo':response.relationships.tag.data.attributes.suffix,
                'prefijo':response.relationships.tag.data.attributes.prefix,
                'posicion':response.relationships.position.data.attributes.name
              });
              if(tipo === 3){
                this.tagsUnion = [];
                this._tagsService.getTagById(tag_id).subscribe((tags:any) => {
                      //this.tagsUnion = tags.data;
                      for(let item of tags.data){
                        let tag = {
                          'id':item.id,
                          'codigo':item.attributes.prefix+'-'+item.attributes.suffix,
                          'elaboracion':item.attributes.elaboration_date,
                          'vencimiento':item.attributes.expiration_date,
                          'lote':item.relationships.lot.data.attributes.code,
                          'producto':item.relationships.product.data.attributes.code,
                          'peso':item.attributes.weight,
                          'ordenproduccion':item.relationships.production_order.data.attributes.number,
                          'cliente':item.relationships.production_order.data.attributes.client
                        }
                        this.tagsUnion.push(tag);
                      }
                      this.alert = 'Caja '+prefijo+'-'+sufijo+' encontrada.';
                      this.isopen = true;
                      this._loaddata.loadChange(100);
                      this.onClosedAutomatic();
                      //console.log("TAGS: ", tags.data);
                    },
                  (error)=>{
                    //console.log("No se han encontrado las cajas");
                  });
              }
              else{
                this.alert = 'Caja '+prefijo+'-'+sufijo+' encontrada.';
                this.isopen = true;
                this._loaddata.loadChange(100);
                this.onClosedAutomatic();
              }

            },
            (error) => {
              this.alert = 'Caja no encontrada en el sistema.';
              this.isopen = true;
              this._loaddata.loadChange(100);
              this.onClosedAutomatic();
            }
          );
        }
        else{
          this.alert = "Codigo QR invalido.";
          this.isopen = true;
          this._loaddata.loadChange(100);
          this.onClosedAutomatic();
        }
      }
    }
  }

  onSearch(e){
    //console.log("Entra a la funcion");
    let qr = this.signupFormBuscar.get('busqueda').value;
    //console.log("QR RECIBIDO: ",qr);
    /*quitar la palabra enter*/
     // if(qr.includes('Enter')){
     //   let separar = qr.split('Enter');
     //   qr = separar[0];
     //   qr = 'P18-0000-112-';
     // }

    this.signupFormBuscar.reset();
    this.signupFormBuscar.patchValue({
      'busqueda': ''
    });
    this.tipoCaja = '';
    this.track_caja = [];
    if(qr != null && qr != ''){
      this.buscarcaja = [];
      this.packingpallet = [];
      this.newpackingpallet = [];
      this.namepackingpallet = '';
      this.alert = "Realizando busqueda.";
      this.isopen = true;
      this._loaddata.loadChange(20);
      let variable = '';
      let guion = 0;
      let prefijopallet = '';
      let sufijocaja = '';
      let prefijo = 0;
      let sufijo = 0;

      /*Derrepente la pistola lee 3 caracteres raros*/
      if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
        qr = qr.substring(3);
      }
      //comprobando si es un pallet al pistolear entrega el formato P18'0000'112Enter
      //let regexp2 = new RegExp("^P\\d{2}[']\\d{4}['][0-9]{1,4}");
      let regexp2 = new RegExp("^P\\d{2}[-]\\d{4}[-][0-9]{1,4}");

      if(regexp2.test(qr)){
        //console.log("Es un pallet CTM",qr);
        let separar = qr.split("-");
        qr = `${separar[0]}-${separar[1]}-${separar[2]}-`;

      }
      else{
        //console.log("Es una caja",qr.length);
      }
      /*P18-0000-131-*/
      let regexp = new RegExp('P\\d{2}-\\d{4}-[0-9]{1,4}-');
      //console.log("QR ANTES DEL REGEXP:",qr);
      if(regexp.test(qr)){
        for(var char of qr){
          if(char != '-'){
            variable += char
          }
          else if(guion == 0){
            variable += '-';
            guion = 1;
          }
          else if(guion == 1){
            prefijopallet = variable;
            variable = '';
            guion = 2;
          }
          else if (guion == 2){
            sufijocaja = variable;
            variable = '';
            guion = 3
          }
        }

        this.code = `${prefijopallet}-${sufijocaja}`;

        this._palletsService.getOneByNumber(prefijopallet+'-'+sufijocaja).subscribe(
          (response:any) => {
            //console.log("respuesta del pallet: ", response);
            if(response.data.length == 0){
              this.alert = "No existe el pallet "+prefijopallet+'-'+sufijocaja+" en el sistema.";
              this.isopen = true;
              this._loaddata.loadChange(100);
            }
            else{
              this.alert = "Pallet "+prefijopallet+"-"+sufijocaja+" encontrado. Generando packing pallet.";
              this.isopen = true;
              this._loaddata.loadChange(50);
              this.namepackingpallet = response.data[0].attributes.number;
              this.cajas_pallet = response.data[0].attributes.amount;
              if(response.data[0].relationships.position.data != null){
                this.ubicacion_Pallet = response.data[0].relationships.position.data.attributes.location;
                this.posicion_Pallet = response.data[0].relationships.position.data.attributes.name;
              }
              else{
                this.ubicacion_Pallet = 'Sin Ubicación';
                this.posicion_Pallet = 'Sin Posición';
              }
              this.detallePallet(response.data[0].id);
              //this.generatePackingPallet(response.data[0].id);
            }
          },
          (error) => {
            this.showError(error.error.error);
          }
        );
      }
      else{
        //console.log("Entro a la caja: ",)
        for(let char of qr){
          if(char != '-'){
            variable += char
          }
          else if(guion == 0){
            prefijo = parseInt(variable);
            variable = '';
            guion = 1;
          }
          else if(guion == 1){
            sufijo = parseInt(variable);
            variable = '';
            guion = 2;
          }
        }

        this.signupFormBuscar.reset();
        this.signupFormBuscar.patchValue({
          'busqueda': ''
        });
        this.code = `${prefijo}-${sufijo}`;
        if(sufijo > 0 && sufijo < 92 && prefijo > 0 &&  isNaN(sufijo) == false && isNaN(prefijo) == false){
          this._stockService.getOneStock(prefijo.toString(),sufijo.toString()).subscribe(
            (response:any) => {

              this._stockService.getOneStockTrack(prefijo.toString(),sufijo.toString()).subscribe((response:any)=>{
                //console.log('respuesta track de caja',response);
                this.track_caja = response.data;
              })
              //console.log("Respuesta Busqueda Codigo caja: ", response.relationships.tag.data.attributes.suffix);
              let tipo = parseInt(response.relationships.tag.data.relationships.box_type.data.id);
              let tag_id = parseInt(response.attributes.tag_id);
              let peso = 0;
              let packing = 'Sin información.';
              let qr = 'Sin información';

              if(tipo === 1){
                this.tipoCaja = 'NORMAL';
              }
              else if(tipo === 2){
                this.tipoCaja = 'SALDO';
              }
              else if(tipo === 3){
                this.tipoCaja = 'UNION DE SALDO';
              }

              if(response.relationships.tag.data.attributes.code != null && response.relationships.tag.data.attributes.code != ''){
                qr = response.relationships.tag.data.attributes.code;
              }

              if(response.relationships.tag.data.relationships.packing.data != null){
                packing = response.relationships.tag.data.relationships.packing.data.id;
              }

              if(parseInt(response.relationships.tag.data.attributes.residue) != 0){
                peso = parseInt(response.relationships.tag.data.attributes.residue);
              }
              else{
                peso = parseInt(response.relationships.tag.data.relationships.product.data.relationships.properties.data[9].attributes.name);
              }
              this.buscarcaja.push({
                'id':response.id,
                'peso':peso,
                'estadotag':response.relationships.tag.data.relationships.tag_status.data.attributes.name,
                'cliente':response.relationships.tag.data.relationships.production_order.data.attributes.client,
                'ordenproduccion':response.relationships.tag.data.relationships.production_order.data.attributes.number,
                'descripcion':response.relationships.tag.data.relationships.product.data.attributes.description,
                'grupo':response.relationships.tag.data.relationships.product.data.attributes.group,
                'producto':response.relationships.tag.data.relationships.product.data.attributes.code,
                'packing':packing,
                'lote':response.relationships.tag.data.relationships.lot.data.attributes.code,
                'tipotag':response.relationships.tag.data.relationships.box_type.data.name,
                'estadostock':response.relationships.status.data.attributes.name,
                'cantidad':response.relationships.pallet.data.attributes.amount,
                'pallet':response.relationships.pallet.data.attributes.number,
                'observacion':response.attributes.observation,
                'elaboracion':response.relationships.tag.data.attributes.elaboration_date,
                'vencimiento':response.relationships.tag.data.attributes.expiration_date,
                'qr':qr,
                'sufijo':response.relationships.tag.data.attributes.suffix,
                'prefijo':response.relationships.tag.data.attributes.prefix,
                'posicion':response.relationships.position.data.attributes.name
              });
              if(tipo === 3){
                this.tagsUnion = [];
                this._tagsService.getTagById(tag_id).subscribe((tags:any) => {
                      //this.tagsUnion = tags.data;
                      for(let item of tags.data){
                        let tag = {
                          'id':item.id,
                          'codigo':item.attributes.prefix+'-'+item.attributes.suffix,
                          'elaboracion':item.attributes.elaboration_date,
                          'vencimiento':item.attributes.expiration_date,
                          'lote':item.relationships.lot.data.attributes.code,
                          'producto':item.relationships.product.data.attributes.code,
                          'peso':item.attributes.weight,
                          'ordenproduccion':item.relationships.production_order.data.attributes.number,
                          'cliente':item.relationships.production_order.data.attributes.client
                        }
                        this.tagsUnion.push(tag);
                      }
                      this.alert = 'Caja '+prefijo+'-'+sufijo+' encontrada.';
                      this.isopen = true;
                      this._loaddata.loadChange(100);
                      this.onClosedAutomatic();
                      //console.log("TAGS: ", tags.data);
                    },
                  (error)=>{
                    //console.log("No se han encontrado las cajas");
                  });
              }
              else{
                this.alert = 'Caja '+prefijo+'-'+sufijo+' encontrada.';
                this.isopen = true;
                this._loaddata.loadChange(100);
                this.onClosedAutomatic();
              }

            },
            (error) => {
              this.alert = 'Caja no encontrada en el sistema.';
              this.isopen = true;
              this._loaddata.loadChange(100);
              this.onClosedAutomatic();
            }
          );
        }
        else{
          this.alert = "Codigo QR invalido.";
          this.isopen = true;
          this._loaddata.loadChange(100);
          this.onClosedAutomatic();
        }
      }
    }
  }

  detallePallet(id_pallet:string){
    this._palletsService.getPalletDetails(id_pallet).subscribe((response:any)=>{
      //console.log("RESPUESTA DETALLE PALLET: ", response);
      if(response.data.length > 0){
        for(let item of response.data){
          let fila = {
            'prefijo': item.attributes.prefix,
            'lote': item.attributes.lot_code,
            'producto': item.attributes.pr_code,
            'total_cajas_normales': item.attributes.normal_box,
            'total_saldos': item.attributes.residue_box,
            'total_cajas':item.attributes.normal_box,
            'peso_cajas_cerradas':item.attributes.total_normal_box,
            'peso_saldos':item.attributes.total_residue,
            'peso_total':item.attributes.total,
            'fecha_elaboracion':item.attributes.elaboration_date,
            'razon_bloqueo':item.attributes.block_reason,
            'comentarios':item.attributes.obs
          }
          this.packingpallet.push(fila);
        }
        this.alert = 'Cajas cargadas';
        this.isopen = true;
        this._loaddata.loadChange(100);
        this.onClosedAutomatic();
      }
      else{
        this.alert = 'Pallet sin cajas';
        this.isopen = true;
        this._loaddata.loadChange(100);
        this.onClosedAutomatic();
      }
    },error=>{
      //console.log("Ha ocurrido un error inesperado: ", error.error.error);
    });
  }

  //Solo para input de prueba
  onSearch2(e){
    let qr = this.signupFormBuscar.get('busqueda').value;
    this.buscarcaja = [];
    this.packingpallet = [];
    this.newpackingpallet = [];
    this.namepackingpallet = '';
    this.alert = "Realizando busqueda.";
    this.isopen = true;
    this._loaddata.loadChange(20);
    let variable = '';
    let guion = 0;
    let prefijopallet = '';
    let sufijocaja = '';
    let prefijo = 0;
    let sufijo = 0;

    /*Derrepente la pistola lee 3 caracteres raros*/
    if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
      qr = qr.substring(3);
    }

    /*P18-0000-131-*/
    if(this.signupFormBuscar.get('busqueda').value.charAt(0) == 'P' && this.signupFormBuscar.get('busqueda').value.charAt(3) == '-' && parseInt(this.signupFormBuscar.get('busqueda').value.charAt(2)) < 9 && parseInt(this.signupFormBuscar.get('busqueda').value.charAt(2)) > 0 && parseInt(this.signupFormBuscar.get('busqueda').value.charAt(1)) < 9 && parseInt(this.signupFormBuscar.get('busqueda').value.charAt(1)) > 0){
      for(var char of qr){
        if(char != '-'){
          variable += char
        }
        else if(guion == 0){
          variable += '-';
          guion = 1;
        }
        else if(guion == 1){
          prefijopallet = variable;
          variable = '';
          guion = 2;
        }
        else if (guion == 2){
          sufijocaja = variable;
          variable = '';
          guion = 3
        }
      }

      this._palletsService.getOneByNumber(prefijopallet+'-'+sufijocaja).subscribe(
        (response:any) => {
          if(response.data.length == 0){
            this.alert = "No existe el pallet "+prefijopallet+'-'+sufijocaja+" en el sistema.";
            this.isopen = true;
            this._loaddata.loadChange(100);
          }
          else{
            this.alert = "Pallet "+prefijopallet+"-"+sufijocaja+" encontrado. Generando packing pallet.";
            this.isopen = true;
            this._loaddata.loadChange(50);
            this.generatePackingPallet(response.data[0].id);
          }
          this.signupFormBuscar.reset();
          this.signupFormBuscar.patchValue({
            'busqueda': ''
          });
        },
        (error) => {
          this.showError(error.error.error);
        }
      );
    }
    else{
      for(let char of qr){
        if(char != '-'){
          variable += char
        }
        else if(guion == 0){
          prefijo = parseInt(variable);
          variable = '';
          guion = 1;
        }
        else if(guion == 1){
          sufijo = parseInt(variable);
          variable = '';
          guion = 2;
        }
      }

      this.signupFormBuscar.reset();
      this.signupFormBuscar.patchValue({
        'busqueda': ''
      });

      if(sufijo > 0 && sufijo < 92 && prefijo > 0 &&  isNaN(sufijo) == false && isNaN(prefijo) == false){
        this._stockService.getOneStock(prefijo.toString(),sufijo.toString()).subscribe(
          (response:any) => {
            let peso = 0;
            let packing = 'Sin información.';
            let qr = 'Sin información';

            if(response.relationships.tag.data.attributes.code != null && response.relationships.tag.data.attributes.code != ''){
              qr = response.relationships.tag.data.attributes.code;
            }

            if(response.relationships.tag.data.relationships.packing.data != null){
              packing = response.relationships.tag.data.relationships.packing.data.id;
            }

            if(parseInt(response.relationships.tag.data.attributes.residue) != 0){
              peso = parseInt(response.relationships.tag.data.attributes.residue);
            }
            else{
              peso = parseInt(response.relationships.tag.data.relationships.product.data.relationships.properties.data[9].attributes.name);
            }
            this.buscarcaja.push({
              'id':response.id,
              'peso':peso,
              'estadotag':response.relationships.tag.data.relationships.tag_status.data.attributes.name,
              'cliente':response.relationships.tag.data.relationships.production_order.data.attributes.client,
              'ordenproduccion':response.relationships.tag.data.relationships.production_order.data.attributes.number,
              'descripcion':response.relationships.tag.data.relationships.product.data.attributes.description,
              'grupo':response.relationships.tag.data.relationships.product.data.attributes.group,
              'producto':response.relationships.tag.data.relationships.product.data.attributes.code,
              'packing':packing,
              'lote':response.relationships.tag.data.relationships.lot.data.attributes.code,
              'tipotag':response.relationships.tag.data.relationships.box_type.data.name,
              'estadostock':response.relationships.status.data.attributes.name,
              'cantidad':response.relationships.pallet.data.attributes.amount,
              'pallet':response.relationships.pallet.data.attributes.number,
              'observacion':response.attributes.observation,
              'elaboracion':response.relationships.tag.data.attributes.elaboration_date,
              'vencimiento':response.relationships.tag.data.attributes.expiration_date,
              'qr':qr,
              'sufijo':response.relationships.tag.data.attributes.suffix,
              'prefijo':response.relationships.tag.data.attributes.prefix,
              'posicion':response.relationships.position.data.attributes.name
            });

            this.alert = 'Caja '+prefijo+'-'+sufijo+' encontrada.';
            this.isopen = true;
            this._loaddata.loadChange(100);
          },
          (error) => {
            this.alert = 'Caja no encontrada en el sistema.';
            this.isopen = true;
            this._loaddata.loadChange(100);
          }
        );
      }
      else{
        this.alert = "Codigo QR invalido.";
        this.isopen = true;
        this._loaddata.loadChange(100);
      }
    }
  }

  generatePackingPallet(id:number):void{
    this.isopen = true;
    this.packingpallet = [];
    this._loaddata.loadChange(70);

    this._stockService.getAllStockFromPallet(id).subscribe(
      (response:any) => {
        //console.log("Cajas del Pallet: ", response);
        if(response.data.length == 0){
          this.alert = "Pallet sin cajas relacionadas.";
        }
        else{
          this.alert = "Packing pallet generado.";
        }
        this.onClosedAutomatic();

        for(let caja of response.data){
          let order_production;
          if(caja.relationships.tag.data.relationships.production_order.data == null){
            order_production = null;
          }
          else{
            order_production = caja.relationships.tag.data.relationships.production_order.data.attributes.number;
          }
          this.packingpallet.push({
            'id':caja.id,
            'idubicacion':caja.relationships.position.data.relationships.location.data.id,
            'ubicacion':caja.relationships.position.data.relationships.location.data.attributes.name,
            'idposicion':caja.attributes.position_id,
            'posicion':caja.relationships.position.data.attributes.name,
            'idpallet':caja.attributes.pallet_id,
            'pallet':caja.relationships.pallet.data.attributes.number,
            'cantidad':caja.relationships.pallet.data.attributes.amount,
            'idtag':caja.attributes.tag_id,
            'fecha':caja.relationships.tag.data.attributes.elaboration_date,
            'prefixtag':caja.relationships.tag.data.attributes.prefix,
            'suffixtag':caja.relationships.tag.data.attributes.suffix,
            'idproducto':caja.relationships.tag.data.attributes.product_id,
            'producto':caja.relationships.tag.data.relationships.product.data.attributes.code,
            'idlote':caja.relationships.tag.data.attributes.lot_id,
            'lote':caja.relationships.tag.data.relationships.lot.data.attributes.code,
            'idop':caja.relationships.tag.data.attributes.production_order_id,
            'op':order_production,
            // 'op':caja.relationships.tag.data.relationships.production_order.data.attributes.number,
            'saldo':caja.relationships.tag.data.attributes.residue,
            'idestadotag':caja.relationships.tag.data.attributes.tag_status_id,
            'idestado':caja.attributes.stock_status_id,
            'estado':caja.relationships.status.data.attributes.name,
            'observacion':caja.attributes.observation,
            'tipo_caja':caja.relationships.tag.data.relationships.box_type.data.attributes.name
          });
        }

        if(this.packingpallet.length != 0){
          this.namepackingpallet = this.packingpallet[0].pallet;
        }
        //console.log("PACKING PALLET: ", this.packingpallet);
        this._loaddata.loadChange(100);
      },
      (error) => {
        this.showError(error.error.error);
      }
    );
  }

  /**
   * Abre una nueva ventana para imprimir las etiquetas QR contenidas
   * en printContents, que a su vez esta relacionado con print-section del html.
   */
  onPrintPackingPallet(): void {
      let printContents, popupWin;
      printContents = document.getElementById('print-packing-pallet').innerHTML;
      popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
      popupWin.document.open();
      popupWin.document.write(`
        <html>
          <head>
            <style></style>
          </head>
          <body onload="window.print();window.close()">
            ${printContents}
          </body>
        </html>`
      );
      popupWin.document.close();
      this.packingpallet = [];
    }

  onGoToReadRealTags():void{
    this.newpackingpallet = [];
    this.corregir = !this.corregir;
  }

  onGoBackPackingMenu():void{
    this.corregir = !this.corregir;
  }

  onReadRealTags():void{
    this.isopen = true;
    let qr = this.signupFormCuadrarPallet.get('busqueda').value;
    let prefijo = '';
    let sufijo = '';
    let guion = 0;
    let variable = '';
    let encontrada = false;

    if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
      qr = qr.substring(3);
    }

    for(let char of qr){
      if(char != '-'){
        variable += char
      }
      else if(guion == 0){
        prefijo = variable;
        variable = '';
        guion = 1;
      }
      else if(guion == 1){
        sufijo = variable;
        variable = '';
        guion = 2;
      }
    }

    this._tagsService.getOnebyPrefixAndSuffix(prefijo,sufijo).subscribe(
      (response:any) => {
        if(response.data.length != 0){
          for(let pk of this.newpackingpallet){
            if(pk.id == response.data[0].id){
              encontrada = true;
              break;
            }
          }
        }

        if(response.data.length == 0){
          this.alert = "No existe etiqueta "+prefijo+"-"+sufijo+".";
        }
        // else if(response.data.length > 1){
        //   this.alert = "Etiqueta "+prefijo+"-"+sufijo+" duplicada. Se debe crear una nueva etiqueta.";
        // }
        else if(encontrada == true){
          this.alert = "Etiqueta "+prefijo+"-"+sufijo+" ya fue cargada.";
        }
        else{
          this.newpackingpallet.push({'id':response.data[0].id,'qr':response.data[0].attributes.code});
          this.alert = "Etiqueta "+prefijo+"-"+sufijo+" encontrada.";
        }

        if(response.data.length > 1){
          this.alert = "Etiqueta "+prefijo+"-"+sufijo+" duplicada.";
        }

        this.isopen = true;
        this._loaddata.loadChange(100);
        this.signupFormCuadrarPallet.reset();
        this.signupFormCuadrarPallet.patchValue({
          'busqueda': ''
        });
      },
      (error) => {
        this.showError(error.error.error);
      }
    );

  }

  onGetIdNewPacking():void{
    this._loaddata.loadChange(30);
    let idsto = 0;

    this.alert = 'Eliminando etiquetas QR del pallet.';
    this.isopen = true;


    if(this.packingpallet.length == 0){
      this._loaddata.loadChange(60);
      this.onCuadrar();
    }
    else{
      for(let sto of this.packingpallet){
        this._stockService.delete2(sto.id).subscribe(
          (response:any) => {

            idsto += 1;
            if(idsto == this.packingpallet.length){
              this.alert = 'Reemplazando etiquetas QR en pallet '+sto.pallet;
              this._loaddata.loadChange(60);
              this.onCuadrar();
            }
          },
          (error) => {
            this.alert += ' Error caja '+sto.prefixtag+'-'+sto.suffixtag+' no pudo ser eliminada.';
            idsto += 1;
            if(idsto == this.packingpallet.length){
              this._loaddata.loadChange(60);
              this.onCuadrar();
            }
          }
        );
      }
    }
  }

  onCuadrar():void{
    this.alert = 'Preparando petición';
    this.isopen = true;
    this._loaddata.loadChange(70);
    let idtag = 0;
    let sto = this.packingpallet[0];
    this.packingpallet = [];

    //Arreglar cuando existan pallets con cajas con varios estados.
    for(let tag of this.newpackingpallet){
      let prov2 = this._stockService.transformData6(sto.idpallet,tag.id,sto.idestado,sto.idposicion,sto.observacion);
      this._stockService.save(prov2).subscribe(
        (response:any) =>{

          idtag += 1;
          if(idtag == this.newpackingpallet.length){
            this.alert = 'Actualización terminada.';
            this._loaddata.loadChange(100);
            this.onBuscar();
            this.signupFormCuadrarPallet.reset();
            this.signupFormCuadrarPallet.patchValue({
              'busqueda': ''
            });
            this.signupFormBuscar.reset();
            this.signupFormBuscar.patchValue({
              'busqueda': ''
            });
          }
        },
        (error) => {
          this.alert += ' Error de actualización '+tag.qr+' .';
          idtag += 1;
          if(idtag == this.newpackingpallet.length){
            this.showError(error.error.error);
          }
        }
      );
    }
  }

  onEntrada():void{
    if(this.etapa == 1){
      this.cajas = [];
      this.pallets = [];
      this.tags = [];
      this.palletsconcajas = [];
      this.ubicacionesconcajas = [];
      this.packings = [];
      this.loadIncomePackings();
    }
    this.buscar = false;
    this.entrada = true;
    this.movimiento = false;
    this.salida = false;
    this.comenzarSalida = false;
  }

  loadIncomePackings():void{
    this.alert = "Cargando Packings."
    this.isopen = true;
    this._loaddata.loadChange(50);
    this._packingecService.getIncomePackings(4).subscribe((response:any) => {
      //console.log("PACKINGS: ", response);
      this._loaddata.loadChange(90);
      for(let pac of response.data){
        if(pac.attributes.total_boxes > 0){
          this.packings.push(pac);
        }
      }
      this.alert = "Carga correcta de Packings."
      this._loaddata.loadChange(100);
      this.onClosedAutomatic();
    },
    (error) => {
      this.showError(error.error.error);
    });
  }

  /**
  * Carga todas las cajas relacionadas al packing.
  * @param packing 1 packing de Empaque -> Camara
  */
  onPackingSelected(packing):void{
    this.trabajando = true;
    this.isopen = true;
    this.alert = 'Preparando petición.'
    this._loaddata.loadChange(30);
    this._tagsService.getTagsFromPacking(packing.id,3).subscribe((response:any) => {
      //console.log("TAGS DEL PACKING: ", response);
      this.tags = response.data;
      this.contadortags = 0;
      this.palletsconcajas = [];
      this.ubicacionesconcajas = [];
      this._loaddata.loadChange(50);
      this.onPackingResolve(true);
    },
    (error) => {
      this.showError(error.error.error);
    });
  }

  onPackingResolve(resp){
    //console.log("ONPACKINGRESOLVE: ", resp);
    this.trabajando = true;
    this.alert = 'Preparando información.';
    this.isopen = true;
    this._loaddata.loadChange(60);
    let idt = 0;
    let op = [];
    this.pallets = [];

    this.cleanSignupForm4();
    this.palletsconcajas = [];
    this.ubicacionesconcajas = [];
    this.cajas = [];
    //console.log("CAJAS DEL PACKING: ", this.tags);
    for(var caja of this.tags){
      this.cajas.push(caja);
      if(!op.includes(caja.relationships.production_order.data.attributes.number)){
        op.push('P'+caja.relationships.production_order.data.attributes.number);
      }
    }
    this._loaddata.loadChange(70);
    //console.log("ARREGLO DE CAJAS: ", this.cajas);
    let generic = parseInt(this.tags[0].relationships.production_order.data.attributes.is_generic);
    let n = this.tags[0].relationships.production_order.data.attributes.number.indexOf("-0000");
    //console.log("N", n,this.tags[0].relationships.production_order.data.attributes.number);
    if(generic == 1 && n == 2){
      this.isgeneric = true;
    }
    else{
      this.isgeneric = false;
    }

    if(this.isgeneric){
      /*son cajas con orden de producción genérica*/
      this._palletsService.getAllGenericPallets().subscribe((response:any)=>{
        //console.log("RESPONSE: ",response.data);
        this.pallets = response.data;
        this.alert = 'Pallets cargados.';
        this.forwardEntrada(2);
        this._loaddata.loadChange(100);
        this.onClosedAutomatic();
        this.etapa = 3;
        this.trabajando = false;

      },(error)=>{
        //console.log("No se han podido cargar los pallets");
      });
    }
    else if(this.isgeneric == false){

      let op = this.tags[0].relationships.production_order.data.attributes.number;
      this._palletsService.getAllByBoxes2(op).subscribe((response:any)=>{
        //console.log("RESPONSE PALLETS: ", response);
        this.alert = 'Pallets cargados.';
        this.trabajando = false;
        for(let pal of response.data){
          this.pallets.push(pal);
        }
        //console.log("PALLETS ARRAY NUEVO: ", this.pallets);
        this.forwardEntrada(2);
        this._loaddata.loadChange(100);
        this.onClosedAutomatic();
        this.etapa = 3;
        this.trabajando = false;

      },(error)=>{
        //console.log("No se cargaron los pallets con prefijo: "+op);
        this.showError(error.error.error);
        this.trabajando = false;
      });
      /*PETICION ANTERIOR*/
      // this._palletsService.getAll().subscribe(
      //   (response:any) => {
      //     console.log("PALLETS: ", response);
      //     this.alert = 'Pallets cargados.';
      //     this.trabajando = false;
      //     for(let pal of response.data){
      //       if(op.includes(pal.attributes.prefix) && (pal.attributes.amount > -1) && (pal.attributes.amount < 90)){
      //         this.pallets.push(pal);
      //       }
      //     }
      //     console.log("PALLETS ARRAY: ", this.pallets);
      //     this.forwardEntrada(2);
      //     this._loaddata.loadChange(100);
      //     this.onClosedAutomatic();
      //     this.etapa = 3;
      //     this.trabajando = false;
      //   },
      //   (error) => {
      //     this.showError(error.error.error);
      //     this.trabajando = false;
      //   }
      // );
    }



  }

  onCreateNewPallet(){
    this.alert = "Cargando pallet."
    this.isopen = true;
    this._loaddata.loadChange(50);

    this.palletsconcajas.push({id:-1,prefijo:'',sufijo:'',amount:0,position:'',positionid:'',number:'',ubicacion:'',ubicacionid:'',boxes:[],qr:'Nuevo Pallet',imprimir:'SI',selected:false,nuevo:true});
    const control = new FormGroup({
      'ubicacion':new FormControl('',Validators.required),
      'posicion': new FormControl('',Validators.required)
    });
    (<FormArray>this.signupForm4.get('palletsnuevos')).push(control);

    this.alert = "Pallet agregado a pantalla de trabajo.";
    this.isopen = true;
    this._loaddata.loadChange(100);
  }

  onSelectedOldPallet(){
    this.alert = "Cargando pallet.";
    this.isopen = true;
    this._loaddata.loadChange(20);
    let repetido = false;

    for(var pal of this.pallets){
      if(parseInt(pal.id) == parseInt(this.signupForm3.get('pallet').value)){
        for(let pallet of this.palletsconcajas){
          if(pallet.id == pal.id){
            repetido = true;
            break;
          }
        }

        if(repetido == false){
          this._loaddata.loadChange(60);
          this._palletsService.getCountStock(pal.attributes.prefix,pal.attributes.suffix).subscribe(
            (response:any) => {
              if(response.data.count != 0){
                //console.log("DATA COUNT != 0");
                this.palletsconcajas.push({id:pal.id,prefijo:pal.attributes.prefix,sufijo:pal.attributes.suffix,amount:response.data.count,position:pal.relationships.position.data.attributes.name,positionid:pal.relationships.position.data.id,number:pal.attributes.number,ubicacion:pal.relationships.position.data.attributes.location,ubicacionid:pal.relationships.position.data.attributes.location_id,boxes:[],qr:pal.attributes.qr_code,imprimir:'SI',selected:false,nuevo:false});
                const control = new FormGroup({
                  'ubicacion':new FormControl(pal.relationships.position.data.attributes.location_id,Validators.required),
                  'posicion': new FormControl(pal.relationships.position.data.id,Validators.required)
                });
                (<FormArray>this.signupForm4.get('palletsnuevos')).push(control);

                this.signupForm3.patchValue({
                  'pallet':'',
                  'ubicacion':'',
                  'busqueda':''
                });

                this._loaddata.loadChange(100);
                this.alert = "Pallet agregado a pantalla de trabajo."
                this.isopen = true;
              }
              else{
                //console.log("DATA COUNT 0");

                this.palletsconcajas.push({id:pal.id,prefijo:pal.attributes.prefix,sufijo:pal.attributes.suffix,amount:response.data.count,position:'',positionid:'',number:pal.attributes.number,ubicacion:'',ubicacionid:'',boxes:[],qr:pal.attributes.qr_code,imprimir:'SI',selected:false,nuevo:true});
                const control = new FormGroup({
                  'ubicacion':new FormControl('',Validators.required),
                  'posicion': new FormControl('',Validators.required)
                });
                (<FormArray>this.signupForm4.get('palletsnuevos')).push(control);

                this.signupForm3.patchValue({
                  'pallet':'',
                  'ubicacion':'',
                  'busqueda':''
                });

                this._loaddata.loadChange(100);
                this.alert = "Pallet agregado a pantalla de trabajo."
                this.isopen = true;
              }
            },
            (error) => {
              this.showError(error.error.error);
            }
          )
          break;
        }
        else{
          this._loaddata.loadChange(100);
          this.alert = "Pallet ya esta en pantalla de trabajo."
          this.isopen = true;
          this.signupForm3.patchValue({
            'pallet':'',
            'ubicacion':'',
            'busqueda':''
          });
          break;
        }
      }
    }
  }

  onSelectedLocation(){
    this.alert = "Agregando ubicación."
    this.isopen = true;
    this._loaddata.loadChange(20);
    let repetido = false;

    for(var pal of this.locaciones){
      if(parseInt(pal.id) == parseInt(this.signupForm3.get('ubicacion').value)){
        for(let ubi of this.ubicacionesconcajas){
          if(ubi.id == pal.id){
            repetido = true;
            break;
          }
        }

        if(repetido == false){
          this._loaddata.loadChange(100);
          this.alert = "Ubicación agregada a pantalla de trabajo."
          this.isopen = true;
          this.ubicacionesconcajas.push({amount:0,id:pal.id,name:pal.attributes.name,boxes:[],selected:false});
          this.signupForm3.patchValue({
            'pallet':'',
            'ubicacion':'',
            'busqueda':''
          });
          break;
        }
        else{
          this._loaddata.loadChange(100);
          this.alert = "Ubicación ya esta en pantalla de trabajo."
          this.isopen = true;
          this.signupForm3.patchValue({
            'pallet':'',
            'ubicacion':'',
            'busqueda':''
          });
          break;
        }
      }
    }
  }

  onClickPallet(id:number){
    for(let item of this.palletsconcajas){
      item.selected = false;
    }
    for(let item of this.ubicacionesconcajas){
      item.selected = false
    }
    this.palletacompletar = id;
    this.ubicacionacompletar = -1
    this.palletsconcajas[id].selected = true;
  }

  onClickLocation(id:number){
    for(let item of this.palletsconcajas){
      item.selected = false;
    }
    for(let item of this.ubicacionesconcajas){
      item.selected = false
    }
    this.palletacompletar = -1;
    this.ubicacionacompletar = id;
    this.ubicacionesconcajas[id].selected = true;
  }

  onClickBox(id:number){
    let op = '';

    if(!(this.palletsconcajas.length == 0 && this.ubicacionesconcajas.length == 0)){
      if(this.palletacompletar != -1){
        for(var char of this.palletsconcajas[this.palletacompletar].prefijo){
          if(char != 'P'){
            op = op+''+char;
          }
        }//Pallet viejo de una OP determinada
        //console.log("OP",op);
        //console.log("OP CAJA", this.cajas[id].relationships.production_order.data.attributes.number);
        /*si es genérica la op se agrega a cualquier pallet genérico sin que la op sea la misma*/
        if(this.isgeneric && this.palletsconcajas[this.palletacompletar].amount < 90){
          this.palletsconcajas[this.palletacompletar].boxes.push(this.cajas[id]);
          this.palletsconcajas[this.palletacompletar].amount += 1;
          this.cajas.splice(id,1);
        }
        else if(op == this.cajas[id].relationships.production_order.data.attributes.number && this.palletsconcajas[this.palletacompletar].amount < 90){
          this.palletsconcajas[this.palletacompletar].boxes.push(this.cajas[id]);
          this.palletsconcajas[this.palletacompletar].amount += 1;
          this.cajas.splice(id,1);
        }//Pallet Nuevo
        else if(this.palletsconcajas[this.palletacompletar].id == -1){
          if(this.palletsconcajas[this.palletacompletar].amount == 0){
            this.palletsconcajas[this.palletacompletar].prefijo = 'P'+this.cajas[id].relationships.production_order.data.attributes.number;
          }
          if(this.palletsconcajas[this.palletacompletar].amount < 90 && this.palletsconcajas[this.palletacompletar].prefijo == 'P'+this.cajas[id].relationships.production_order.data.attributes.number){
            this.palletsconcajas[this.palletacompletar].boxes.push(this.cajas[id]);
            this.palletsconcajas[this.palletacompletar].amount += 1;
            this.cajas.splice(id,1);
          }
        }
      }
      else{//Ubicación
        if(this.ubicacionacompletar != -1){
          this.ubicacionesconcajas[this.ubicacionacompletar].boxes.push(this.cajas[id]);
          this.ubicacionesconcajas[this.ubicacionacompletar].amount += 1;
          this.cajas.splice(id,1);
        }
      }
    }
  }

  onMoveAll(){
    let op = '';
    if(!(this.palletacompletar == -1 && this.ubicacionacompletar == -1)){
      if(this.palletacompletar != -1){
        for(var char of this.palletsconcajas[this.palletacompletar].prefijo){
          if(char != 'P'){
            op = op+''+char;
          }
        }

        for(let caja of this.cajas){
          if(op == caja.relationships.production_order.data.attributes.number){
            this.palletsconcajas[this.palletacompletar].boxes.push(caja);
            this.palletsconcajas[this.palletacompletar].amount += 1;
          }//Pallet Nuevo
          else if(this.palletsconcajas[this.palletacompletar].id == -1){
            if(this.palletsconcajas[this.palletacompletar].amount == 0){
              this.palletsconcajas[this.palletacompletar].prefijo = 'P'+caja.relationships.production_order.data.attributes.number;
            }
            if(this.palletsconcajas[this.palletacompletar].prefijo == 'P'+caja.relationships.production_order.data.attributes.number){
              this.palletsconcajas[this.palletacompletar].boxes.push(caja);
              this.palletsconcajas[this.palletacompletar].amount += 1;
            }
          }
        }
      }
      else if(this.ubicacionacompletar != -1){
        for(let caja of this.cajas){
          this.ubicacionesconcajas[this.ubicacionacompletar].boxes.push(caja);
          this.ubicacionesconcajas[this.ubicacionacompletar].amount += 1;
        }
      }
      this.cajas = [];
    }
  }

  onAddTag(e){
    let qr = this.signupForm3.get('busqueda').value;
    let guion = 0;
    let prefijo = '';
    let sufijo = '';
    let variable = '';
    let id = -1;
    let pos = 0;

    if(qr != null && qr != ''){
      if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
        qr = qr.substring(3);
      }

      for (var char of qr) {
        if(char != '-'){
          variable += char;
        }
        else if(guion == 0){
          prefijo = variable;
          variable = '';
          guion = 1;
        }
        else if(guion == 1){
          sufijo = variable;
          variable = '';
          guion = 2;
        }
      }

      for(let caja of this.cajas){
        if(caja.attributes.prefix == prefijo && caja.attributes.suffix == sufijo){
          id = pos;
          break;
        }
        pos += 1;
      }

      this.signupForm3.reset();
      this.signupForm3.patchValue({
        'busqueda': '',
      });

      if(id != -1){
        this.onClickBox(id);
      }
    }
  }

  //Solo para input de prueba
  onAddTag2(e){
      let qr = this.signupForm3.get('busqueda').value;
      let guion = 0;
      let prefijo = '';
      let sufijo = '';
      let variable = '';
      let id = -1;
      let pos = 0;

      if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
        qr = qr.substring(3);
      }

      for (var char of qr) {
        if(char != '-'){
          variable += char;
        }
        else if(guion == 0){
          prefijo = variable;
          variable = '';
          guion = 1;
        }
        else if(guion == 1){
          sufijo = variable;
          variable = '';
          guion = 2;
        }
      }

      for(let caja of this.cajas){
        if(caja.attributes.prefix == prefijo && caja.attributes.suffix == sufijo){
          id = pos;
          break;
        }
        pos += 1;
      }

      this.signupForm3.reset();
      this.signupForm3.patchValue({
        'busqueda': '',
      });

      if(id != -1){
        this.onClickBox(id);
      }

  }

  onClickBoxWithPalletOrLocation(idcaja:number,id:number,tipo:string){
    if(tipo == 'p'){
      this.cajas.push(this.palletsconcajas[id].boxes[idcaja]);
      this.palletsconcajas[id].amount -= 1;
      this.palletsconcajas[id].boxes.splice(idcaja,1);
    }
    else{
      if(tipo == 'u'){
        this.cajas.push(this.ubicacionesconcajas[id].boxes[idcaja]);
        this.ubicacionesconcajas[id].amount -= 1;
        this.ubicacionesconcajas[id].boxes.splice(idcaja,1);
      }
    }
  }

  putSelectedLocation(pos:number){
    this.isopen = true;
    this.alert = 'Cargando posiciones.';
    this._loaddata.loadChange(40);

    this._locationService.freePositionsFromLocation((<FormArray>this.signupForm4.get('palletsnuevos')).controls[pos].value.ubicacion).subscribe(
      (response:any) => {
        this._loaddata.loadChange(70);
        this.palletsconcajas[pos].ubicacionid = (<FormArray>this.signupForm4.get('palletsnuevos')).controls[pos].value.ubicacion;

        for(let ubicacion of this.locaciones){
          if(this.palletsconcajas[pos].ubicacionid == ubicacion.id){
            this.palletsconcajas[pos].ubicacion = ubicacion.attributes.name;
            break;
          }
        }

        this.palletsconcajas[pos].positions = [];
        for(let position of response.data){
          this.palletsconcajas[pos].positions.push(position);
        }
        (<FormArray>this.signupForm4.get('palletsnuevos')).controls[pos].patchValue({
          'posicion':null
        });
        this.palletsconcajas[pos].position = '';
        this.alert = 'Posiciones cargadas.';
        this._loaddata.loadChange(100);
      },
      (error) => {
        this.showError(error.error.error);
      }
    )
  }

  putSelectedPosition(pos:number){
    this.palletsconcajas[pos].positionid = (<FormArray>this.signupForm4.get('palletsnuevos')).controls[pos].value.posicion;
    for(let posicion of this.palletsconcajas[pos].positions){
      if(this.palletsconcajas[pos].positionid == posicion.id){
        this.palletsconcajas[pos].position = posicion.attributes.name;
        break;
      }
    }
  }

  deleteUbicacion(pos:number){
    for(let caja of this.ubicacionesconcajas[pos].boxes){
      this.cajas.push(caja);
    }
    this.ubicacionesconcajas.splice(pos,1);
    this.palletacompletar = -1;
    this.ubicacionacompletar = -1;
  }

  deletePallet(pos:number){
    if(!(this.palletacompletar == -1 && this.ubicacionacompletar == -1)){
      if(this.palletacompletar == -1){
        this.ubicacionesconcajas[this.ubicacionacompletar].selected = false;
        this.ubicacionacompletar = -1;
      }
      else if(this.ubicacionacompletar == -1){
        this.palletsconcajas[this.palletacompletar].selected = false;
        this.palletacompletar = -1;
      }
    }

    for(let caja of this.palletsconcajas[pos].boxes){
      this.cajas.push(caja);
    }
    this.palletsconcajas.splice(pos,1);
    (<FormArray>this.signupForm4.get('palletsnuevos')).removeAt(pos);
  }

  calculatePrefixSuffix():void{
    let prefix = '';
    let suffix = 1;
    let encontrado = false;
    let prefijos = [];

    for(let pallet of this.palletsconcajas){
      encontrado = false;
      if(pallet.id == -1){
        for(let prefi of prefijos){
          if(pallet.prefijo == prefi.prefijo){
            prefi.cantidad += 1;
            pallet.sufijo = prefi.cantidad;
            encontrado = true;
            break;
          }
        }
        if(encontrado == false){
          prefijos.push({prefijo:pallet.prefijo,cantidad:1});
          pallet.sufijo = 1;
        }
      }
    }


  }

  sumary():void{
    this.trabajando = true;
    let idp = 0;
    let idu = 0;
    let idpallet = -1;
    this.alert = 'Generando petición.';
    this.isopen = true;
    this.paso1 = false;
    this.paso2 = false;
    let that = this;
    this._loaddata.loadChange(40);

    for(let pallet of this.palletsconcajas){
      idp += 1;
      //Pallet nuevo
      if(pallet.id == -1){
        this.alert = 'Creando nuevo pallet';
        let prov = this._palletsService.transformData4(pallet.prefijo);
        this._palletsService.save(prov).subscribe(
          (response:any) =>{
            this.alert = 'Pallet creado. Almacenando cajas en pallet.';
            pallet.id = response.id;
            pallet.number = response.attributes.number;
            pallet.qr = response.attributes.qr_code;
            pallet.sufijo = response.attributes.suffix;
            let prov = this._stockService.transformData7(pallet);
            this._stockService.saveAll(prov).subscribe(
              response =>{
                this.alert = 'Cajas almacenadas. Cambiando estado de etiquetas.';
                let prov2= this._tagsService.transformData7(pallet.boxes,3);
                this._tagsService.update(prov2).subscribe(
                  response =>{
                    if(idp == this.palletsconcajas.length){
                      this.alert = 'Etiquetas QR actualizadas. Cambiando estado de packing.';
                      this.paso1 = true;
                      idp = 0;
                      this._loaddata.loadChange(60);
                      this.changePackingState();
                    }
                  },
                  (error) => {
                    this.alert = error.error.error;
                    if(idp == this.palletsconcajas.length){
                      idp = 0;
                      this._loaddata.loadChange(60);
                    }
                  }
                );
              },
              (error) => {
                this.alert = error.error.error;
                if(idp == this.palletsconcajas.length){
                  idp = 0;
                  this._loaddata.loadChange(100);
                }
              }
            );
          },
          (error) => {
            this.alert = error.error.error;
            if(idp == this.palletsconcajas.length){
              idp = 0;
              this._loaddata.loadChange(100);
            }
          }
        );
      }//Ya existe el pallet
      else{
        let prov = this._stockService.transformData7(pallet);
        this._stockService.saveAll(prov).subscribe(
          response =>{
            this.alert = 'Cajas almacenadas en pallet. Cambiando estado de etiquetas.';
            let prov2= this._tagsService.transformData7(pallet.boxes,3);
            this._tagsService.update(prov2).subscribe(
              response =>{
                if(idp == this.palletsconcajas.length){
                  this.alert = 'Etiquetas QR actualizadas. Cambiando estado de packing.';
                  this.paso1 = true;
                  idp = 0;
                  this._loaddata.loadChange(60);
                  this.changePackingState();
                }
              },
              (error) => {
                this.alert = error.error.error;
                if(idp == this.palletsconcajas.length){
                  idp = 0;
                  this._loaddata.loadChange(100);
                }
              }
            );
          },
          (error) => {
            this.alert = error.error.error;
            if(idp == this.palletsconcajas.length){
              idp = 0;
              this._loaddata.loadChange(100);
            }
          }
        );
      }
    }

    idu = 0;
    for(let ubicacion of this.ubicacionesconcajas){
      this.alert = 'Preparando ubicaciones';
      let idubicacion = ubicacion.id;
      let idposicion = this.posicionesvacias.find(o => o.idubicacion == ubicacion.id).idposicion;
      let idc = 0;
      idu += 1;

      for(let caja of ubicacion.boxes){
        let prov2 = this._stockService.transformData2(caja,idubicacion,idposicion);
        setTimeout(function(){
          that._stockService.save(prov2).subscribe(
            (response:any) =>{
              that.alert = 'Caja guardada en ubicación.';
              let prov3= that._tagsService.transformData4(response.attributes.tag_id);
              that._tagsService.update2(response.attributes.tag_id,prov3).subscribe(
                (response:any) =>{
                  that.alert = 'Etiqueta QR cambio de estado.';
                  idc += 1;
                  if((idu == that.ubicacionesconcajas.length) && (idc == ubicacion.boxes.length)){
                    that.alert = 'Todas las cajas han sido almacenadas en las ubicaciones.'
                    that.paso2 = true;
                    idu = 0;
                    that._loaddata.loadChange(60);
                    that.changePackingState();
                  }
                },
                (error) => {
                  idc += 1;
                  that.alert = error.error.error;
                  if((idu == that.ubicacionesconcajas.length) && (idc == ubicacion.boxes.length)){
                    that.paso2 = false;
                    idu = 0;
                    that._loaddata.loadChange(100);
                  }
                }
              );
            },
            (error) => {
              that.alert = error.error.error;
              if((idu == that.ubicacionesconcajas.length) && (idc == ubicacion.boxes.length)){
                that.paso2 = false;
                idu = 0;
                that._loaddata.loadChange(100);
              }
            }
          );
        }, 100);
      }
    }
  }

  changePackingState(){
    if(this.palletsconcajas.length == 0){
      this.paso1 = true;
    }

    if(this.ubicacionesconcajas.length == 0){
      this.paso2 = true;
    }

    if((this.paso1 == true) && (this.paso2 == true)){
      let idpacking = -1;
      if(this.palletsconcajas.length != 0){
        idpacking = this.palletsconcajas[0].boxes[0].relationships.packing.data.id;
      }
      else if(this.ubicacionesconcajas.length != 0){
        idpacking = this.ubicacionesconcajas[0].boxes[0].relationships.packing.data.id;
      }

      this._loaddata.loadChange(80);

      let prov = this._packingecService.transformData2(2,idpacking);
      this._packingecService.update2(prov,idpacking).subscribe(
        (response:any) => {
          this.alert = 'Packing '+idpacking+' aceptado sin problemas.';
          this.trabajando = false;
          this.paso1 = false;
          this.paso2 = false;
          this.etapa = 1;
          this._loaddata.loadChange(100);
          this.qrPallet();
        },
        (error) => {
          this.showError(error.error.error);
        }
      );
    }
  }

  /**
   * Limpia el formulario de entradas de pallets nuevos para volver a utilizarlo despues.
   */
    cleanSignupForm4():void{
      this.signupForm4.reset();
      this.signupForm4 = new FormGroup({
        'palletsnuevos':new FormArray([])
      });
    }

  qrPallet(){
    if(this.palletsconcajas.length != 0){
      this.print();
      this.onEntrada();
    }
    else{
      this.onEntrada();
    }
  }

  /**
   * Abre una nueva ventana para imprimir las etiquetas QR contenidas
   * en printContents, que a su vez esta relacionado con print-section del html.
   */
   private print(): void {
     let printContents, popupWin;
     printContents = document.getElementById('print-section').innerHTML;
     popupWin = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
     popupWin.document.open();
     popupWin.document.write(`
       <html>
       <head>
       <style></style>
       </head>
       <body onload="window.print();window.close()">
       ${printContents}
       </body>
       </html>`
     );
     popupWin.document.close();
   }

  reverseEntrada(etapa:number){
    if(etapa == 2){
      this.etapa = 1;
    }
    else if(etapa == 3){
      for(let item of this.palletsconcajas){
        item.selected = false;
      }
      for(let item of this.ubicacionesconcajas){
        item.selected = false
      }
      this.etapa = 2;
    }
    else if(etapa == 4){
      this.etapa = 3;
    }
    else if(etapa == 5){
      this.etapa = 4;
    }
  }

  forwardEntrada(etapa:number){
    if(etapa == 1){
      this.etapa = 2;
    }
    else if(etapa == 2){
      this.etapa = 3;
    }
    else if(etapa == 3){
      let idp = 0;
      let idu = 0;

      for(let i = 0;i < this.palletsconcajas.length;i++){
        if(this.palletsconcajas[i].boxes.length == 0){
          this.palletsconcajas.splice(i,1);
          (<FormArray>this.signupForm4.get('palletsnuevos')).removeAt(i);
          i--;
        }
        else{
          this.palletsconcajas[i].selected = false;
        }
      }

      for(let i = 0;i < this.ubicacionesconcajas.length;i++){
        if(this.ubicacionesconcajas[i].boxes.length == 0){
          this.ubicacionesconcajas.splice(i,1);
          i--;
        }
        else{
          this.ubicacionesconcajas[i].selected = false;
        }
      }
      this.calculatePrefixSuffix();
      this.etapa = 4;
    }
    else if(etapa == 4){
      this.etapa = 5;
    }
    else if(etapa == 5){
      this.trabajando = true;
      this.sumary();
    }
  }

  reverseEntradaMov(etapamov:number){
    if(etapamov == 0){
      this.etapamov = 1;
    }
    if(etapamov == 2){
      this.etapamov = 1;
    }
    else if(etapamov == 3){
      this.etapamov = 1;
    }
    else if(etapamov == 4){
      this.etapamov = 2;
    }
    else if(etapamov == 5){
      this.etapamov = 3;
    }
    else if(etapamov == 6){
      this.etapamov = 4;
    }
    else if(etapamov == 7){
      this.updateCajasReturn();
      this.etapamov = 5;
    }
  }

  forwardEntradaMov(etapamov:number){
    if(etapamov == 1){
      this.etapamov = 3;
    }
    else if(etapamov == 0){
      this.etapamov = 2;
    }
    else if(etapamov == 2){
      this.loadPallets();
      this.etapamov = 4;
    }
    else if(etapamov == 3){
      this.loadCajas();
      this.etapamov = 5;
    }
    else if(etapamov == 4){
      this.etapamov = 6;
    }
    else if(etapamov == 5){
      this.updateCajas();
      this.etapamov = 7;
    }
  }

onMovimiento():void{
  this.buscar = false;
  this.entrada = false;
  this.movimiento = true;
  this.salida = false;
  this.cajas2 = [];
  this.pallets2 = [];
  this.comenzarSalida = false;
}
//funcion que busca un pallet en la seccion movimientos de pallet
onCheckTagMovPalletNew(q){
  //let qr = this.signupFormMov0.get('busqueda').value;
  let qr=q;
  //console.log("codigo Pallet?:",qr);
  if(qr != null && qr != ''){
    let guion = 0;
    let prefijo = '';
    let sufijo = '';
    let variable = '';
    let pallet = '';
    let cliente = '';
    let fecha = '';
    let lote = '';
    let producto = '';
    let especie = '';
    let antiguo = '';

    //comprobando si es un pallet al pistolear entrega el formato P18'0000'112Enter
    //let regexp2 = new RegExp("^P\\d{2}[']\\d{4}['][0-9]{1,4}");
    let regexp2 = new RegExp("^P\\d{2}[-]\\d{4}[-][0-9]{1,4}");
    if(regexp2.test(qr)){
      //console.log("PALLET",qr);
      let separar = qr.split("-");
      qr = `${separar[0]}-${separar[1]}-${separar[2]}-`;
    }

    let regexp = new RegExp('P\\d{2}-\\d{4}-[0-9]{1,4}-');
    if(regexp.test(qr)){
      for(var char of qr){
        if(char != '-'){
          variable += char
        }
        else if(guion == 0){
          variable += '-';
          guion = 1;
        }
        else if(guion == 1){
          prefijo = variable;
          variable = '';
          guion = 2;
        }
        else if (guion == 2){
          sufijo = variable;
          variable = '';
          guion = 3
        }
      }
      antiguo = variable;
    }

    //Busca si ya se ingreso ese qr para mover.
    if(prefijo != '' && sufijo != ''){
      let repetido = false;
      for(let pal of this.pallets2){
        if(pal.prefijo == prefijo && pal.sufijo == sufijo){
          repetido = true;
          break;
        }
      }
      if(repetido == false){
        this.pallets2.push({sufijo:sufijo,prefijo:prefijo,extra:antiguo});
      }
    }

      this.signupFormMov0.reset();
      this.signupFormMov0.patchValue({
        'busqueda': '',
      });
  }
}

onCheckTagMovPallet(e){
  let qr = this.signupFormMov0.get('busqueda').value;
  if(qr != null && qr != ''){
    let guion = 0;
    let prefijo = '';
    let sufijo = '';
    let variable = '';
    let pallet = '';
    let cliente = '';
    let fecha = '';
    let lote = '';
    let producto = '';
    let especie = '';
    let antiguo = '';

    let regexp = new RegExp('P\\d{2}-\\d{4}-[0-9]{1,4}-');
    if(regexp.test(qr)){
      for(var char of qr){
        if(char != '-'){
          variable += char
        }
        else if(guion == 0){
          variable += '-';
          guion = 1;
        }
        else if(guion == 1){
          prefijo = variable;
          variable = '';
          guion = 2;
        }
        else if (guion == 2){
          sufijo = variable;
          variable = '';
          guion = 3
        }
      }
      antiguo = variable;
    }

    //Busca si ya se ingreso ese qr para mover.
    if(prefijo != '' && sufijo != ''){
      let repetido = false;
      for(let pal of this.pallets2){
        if(pal.prefijo == prefijo && pal.sufijo == sufijo){
          repetido = true;
          break;
        }
      }
      if(repetido == false){
        this.pallets2.push({sufijo:sufijo,prefijo:prefijo,extra:antiguo});
      }
    }

      this.signupFormMov0.reset();
      this.signupFormMov0.patchValue({
        'busqueda': '',
      });
  }
}

//Solo para input de prueba
onCheckTagMovPallet2(e){
  let qr = this.signupFormMov0.get('busqueda').value;
  let guion = 0;
  let prefijo = '';
  let sufijo = '';
  let variable = '';
  let pallet = '';
  let cliente = '';
  let fecha = '';
  let lote = '';
  let producto = '';
  let especie = '';
  let antiguo = '';

  if(qr.charAt(0) == 'P'){
    for(var char of qr){
      if(char != '-'){
        variable += char
      }
      else if(guion == 0){
        variable += '-';
        guion = 1;
      }
      else if(guion == 1){
        prefijo = variable;
        variable = '';
        guion = 2;
      }
      else if (guion == 2){
        sufijo = variable;
        variable = '';
        guion = 3
      }
    }
    antiguo = variable;
  }

  //Busca si ya se ingreso ese qr para mover.
  if(prefijo != '' && sufijo != ''){
    let repetido = false;
    for(let pal of this.pallets2){
      if(pal.prefijo == prefijo && pal.sufijo == sufijo){
        repetido = true;
        break;
      }
    }
    if(repetido == false){
      this.pallets2.push({sufijo:sufijo,prefijo:prefijo,extra:antiguo});
    }
  }

  this.signupFormMov0.reset();
  this.signupFormMov0.patchValue({
    'busqueda': '',
  });
}

  onCheckPosition(){
    this.alert = 'Revisando asignación de posiciones.';
    this.isopen = true;
    this._loaddata.loadChange(50);
    let repetido = false;

    for(let pallet1 of (<FormArray>this.signupFormMov2.get('pallets')).controls){
      for(let pallet2 of (<FormArray>this.signupFormMov2.get('pallets')).controls){
        if(pallet1.value.posicion != 'S/P' && pallet2.value.posicion != 'S/P' && pallet1.value.id != pallet2.value.id && pallet1.value.idposicion == pallet2.value.idposicion){
          repetido = true;
          break;
        }
      }
      if(repetido == true){
        break;
      }
    }

    if(repetido == true){
      this.alert = "Error, existen posiciones duplicadas en el movimiento.";
      this._loaddata.loadChange(100);
    }
    else{
      this.forwardEntradaMov(4);
      this._loaddata.loadChange(100);
    }
    this.onClosedAutomatic();
  }

  /*para agregar cajas a mover con la pistola*/
  onCheckTagMovCajaNew(q){
    //let qr = this.signupFormMov1.get('busqueda').value;
    let qr = q;
    if(qr != null && qr != ''){
      let guion = 0;
      let prefijo = '';
      let sufijo = '';
      let variable = '';
      let pallet = '';
      let cliente = '';
      let fecha = '';
      let lote = '';
      let producto = '';
      let op = '';
      let peso = '';

      if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
        qr = qr.substring(3);
      }

      //console.log("CODIGO RECIBIDO:", qr);
      //Si es Caja
      if(parseInt(qr.charAt(0)) >= 0 &&  parseInt(qr.charAt(0)) <= 9){
        //console.log("ENTRO A CONDICION:", qr);
        for (var char of qr) {
          if(char != "-"){
            variable += char;
          }
          else if(guion == 0){
            prefijo = variable;
            variable = '';
            guion = 1;
          }
          else if(guion == 1){
            sufijo = variable;
            variable = '';
            guion = 2;
          }
          else if(guion == 2){
            producto = variable;
            variable = '';
            guion = 3;
          }
          else if(guion == 3){
            fecha = variable;
            variable = '';
            guion = 4;
          }
          else if(guion == 4){
            lote = variable;
            variable = '';
            guion = 5;
          }
          else if(guion == 5){
            guion = 6;
          }
          else if(guion == 6){
            op = variable;
            variable = '';
            guion = 7;
          }
          else if(guion == 7){
            peso = variable;
            variable = '';
            guion = 8;
          }
        }
        let quitar_enter = variable.split("Enter");
        cliente = quitar_enter[0];
        //cliente = variable;

        // let separar = qr.split("''");
        // prefijo = separar[0];
        // sufijo = separar[1];
        //console.log("Prefijo: ",prefijo);
        //console.log("Sufijo: ",sufijo);
      }

      if(prefijo != '' && sufijo != ''){
        let repetido = false;
        for(let caja of this.cajas2){
          if((caja.prefijo == prefijo) && (caja.sufijo == sufijo)){
            repetido = true;
            break;
          }
        }
        if(repetido == false){
          this.cajas2.push({prefijo:prefijo,sufijo:sufijo,producto:producto,lote:lote,fecha:fecha,cliente:cliente,peso:peso,op:op});
        }
      }

      this.signupFormMov1.reset();
      this.signupFormMov1.patchValue({
        'busqueda': '',
      });
    }
  }

  onCheckTagMovCaja(e){
    let qr = this.signupFormMov1.get('busqueda').value;
    if(qr != null && qr != ''){
      let guion = 0;
      let prefijo = '';
      let sufijo = '';
      let variable = '';
      let pallet = '';
      let cliente = '';
      let fecha = '';
      let lote = '';
      let producto = '';
      let op = '';
      let peso = '';

      if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
        qr = qr.substring(3);
      }

      //Si es Caja
      if(parseInt(qr.charAt(0)) >= 0 &&  parseInt(qr.charAt(0)) <= 9){
        for (var char of qr) {
          if(char != '-'){
            variable += char;
          }
          else if(guion == 0){
            prefijo = variable;
            variable = '';
            guion = 1;
          }
          else if(guion == 1){
            sufijo = variable;
            variable = '';
            guion = 2;
          }
          else if(guion == 2){
            producto = variable;
            variable = '';
            guion = 3;
          }
          else if(guion == 3){
            fecha = variable;
            variable = '';
            guion = 4;
          }
          else if(guion == 4){
            lote = variable;
            variable = '';
            guion = 5;
          }
          else if(guion == 5){
            guion = 6;
          }
          else if(guion == 6){
            op = variable;
            variable = '';
            guion = 7;
          }
          else if(guion == 7){
            peso = variable;
            variable = '';
            guion = 8;
          }
        }
        cliente = variable;
      }

      if(prefijo != '' && sufijo != ''){
        let repetido = false;
        for(let caja of this.cajas2){
          if((caja.prefijo == prefijo) && (caja.sufijo == sufijo)){
            repetido = true;
            break;
          }
        }
        if(repetido == false){
          this.cajas2.push({prefijo:prefijo,sufijo:sufijo,producto:producto,lote:lote,fecha:fecha,cliente:cliente,peso:peso,op:op});
        }
      }

      this.signupFormMov1.reset();
      this.signupFormMov1.patchValue({
        'busqueda': '',
      });
    }
  }

  //Solo para input de prueba
  onCheckTagMovCaja2(e){
    let qr = this.signupFormMov1.get('busqueda').value;
    let guion = 0;
    let prefijo = '';
    let sufijo = '';
    let variable = '';
    let pallet = '';
    let cliente = '';
    let fecha = '';
    let lote = '';
    let producto = '';
    let op = '';
    let peso = '';

    if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
      qr = qr.substring(3);
    }

    //Si es Caja
    if(parseInt(qr.charAt(0)) >= 0 &&  parseInt(qr.charAt(0)) <= 9){
    for (var char of qr) {
      if(char != '-'){
        variable += char;
      }
      else if(guion == 0){
        prefijo = variable;
        variable = '';
        guion = 1;
      }
      else if(guion == 1){
        sufijo = variable;
        variable = '';
        guion = 2;
      }
      else if(guion == 2){
        producto = variable;
        variable = '';
        guion = 3;
      }
      else if(guion == 3){
        fecha = variable;
        variable = '';
        guion = 4;
      }
      else if(guion == 4){
        lote = variable;
        variable = '';
        guion = 5;
      }
      else if(guion == 5){
        guion = 6;
      }
      else if(guion == 6){
        op = variable;
        variable = '';
        guion = 7;
      }
      else if(guion == 7){
        peso = variable;
        variable = '';
        guion = 8;
      }
    }
    cliente = variable;
  }

  if(prefijo != '' && sufijo != ''){
    let repetido = false;
    for(let caja of this.cajas2){
      if((caja.prefijo == prefijo) && (caja.sufijo == sufijo)){
        repetido = true;
        break;
      }
    }
    if(repetido == false){
      this.cajas2.push({prefijo:prefijo,sufijo:sufijo,producto:producto,lote:lote,fecha:fecha,cliente:cliente,peso:peso,op:op});
    }
  }

  this.signupFormMov1.reset();
  this.signupFormMov1.patchValue({
    'busqueda': '',
  });
}

  deletePalletMov(pos:number){
    this.pallets2.splice(pos,1);
  }

  deleteCajaMov(pos:number){
    this.cajas2.splice(pos,1);
  }

  loadPallets(){
    this.alert = 'Cargando información de pallets.';
    this.isopen = true;
    this._loaddata.loadChange(20);

    let that=this;
    let indice = 0;
    this.palletencontrado = false;

    while((<FormArray>that.signupFormMov2.get('pallets')).controls.length > 0){
      (<FormArray>that.signupFormMov2.get('pallets')).removeAt((<FormArray>that.signupFormMov2.get('pallets')).controls.length - 1);
    }
    this.signupFormMov2.reset();
    this.positions = [];

    setTimeout(function(){
      for(let pal of that.pallets2){
        that._palletsService.getOne(pal.prefijo,pal.sufijo).subscribe(
          (response:any) => {
            if(response.data.length != 0){
              let qr = '';
              let pa = response.data[0];

              if(response.data[0].attributes.amount != 0){
                that._locationService.freePositionsFromLocation(pa.relationships.position.data.attributes.location_id).subscribe(
                  (response:any) => {
                    that.positions.push(response.data);

                    that.palletencontrado = true;
                    if(pa.attributes.qr_code != null){
                      qr = pa.attributes.qr_code;
                    }

                    const control = new FormGroup({
                      'id':new FormControl(pa.id),
                      'qr':new FormControl(qr),
                      'codigo': new FormControl(pa.attributes.number),
                      'cantidad': new FormControl (pa.attributes.amount),
                      'idubicacion':new FormControl(null,Validators.required),
                      'idposicion':new FormControl(null,Validators.required),
                      'ubicacion':new FormControl(pa.relationships.position.data.attributes.location,Validators.required),
                      'posicion': new FormControl(pa.relationships.position.data.attributes.name,Validators.required),
                      'prefijo': new FormControl(pa.attributes.prefix,Validators.required),
                      'sufijo': new FormControl(pa.attributes.suffix,Validators.required),
                      'ubicacionantigua':new FormControl(pa.relationships.position.data.attributes.location,Validators.required),
                      'posicionantigua': new FormControl(pa.relationships.position.data.attributes.name,Validators.required),
                      'existe':new FormControl(true),
                      'guia':new FormControl('',Validators.required)
                    });
                    (<FormArray>that.signupFormMov2.get('pallets')).push(control);

                    indice += 1;
                    if(indice == that.pallets2.length){
                      if(that.alert != 'Cargando información de pallets.'){
                        that.alert = 'Carga de pallets realizada de forma incompleta.';
                      }
                      else{
                        that.alert = 'Pallets cargados.';
                      }
                      that.isopen = true;
                      that._loaddata.loadChange(100);

                          setTimeout(()=>{
                          that.isopen = false;
                        }, 3000);


                    }
                  },
                  (error) => {
                    that.showError(error.error.error);
                  }
                )
              }
              else{
                indice += 1;
                that.alert = 'Error pallet '+pal.prefijo+'-'+pal.sufijo+' sin cajas. ';

                const control = new FormGroup({
                  'id':new FormControl(-1),
                  'qr':new FormControl(''),
                  'codigo': new FormControl(pal.prefijo+'-'+pal.sufijo),
                  'cantidad': new FormControl (0),
                  'idubicacion':new FormControl(-1),
                  'idposicion':new FormControl(-1),
                  'ubicacion':new FormControl(''),
                  'posicion': new FormControl(''),
                  'prefijo': new FormControl(pal.prefijo),
                  'sufijo': new FormControl(pal.sufijo),
                  'ubicacionantigua':new FormControl(''),
                  'posicionantigua': new FormControl(''),
                  'existe':new FormControl(false),
                  'guia':new FormControl('')
                });
                (<FormArray>that.signupFormMov2.get('pallets')).push(control);

                if(indice == that.pallets2.length){
                  that.alert = 'Existen busquedas sin resultados.';
                  that.isopen = true;
                  that._loaddata.loadChange(100);
                }
              }
            }
            else{
              indice += 1;
              that.alert = 'Error pallet '+pal.prefijo+'-'+pal.sufijo+' sin cajas. ';

              const control = new FormGroup({
                'id':new FormControl(-1),
                'qr':new FormControl(''),
                'codigo': new FormControl(pal.prefijo+'-'+pal.sufijo),
                'cantidad': new FormControl (0),
                'idubicacion':new FormControl(-1),
                'idposicion':new FormControl(-1),
                'ubicacion':new FormControl(''),
                'posicion': new FormControl(''),
                'prefijo': new FormControl(pal.prefijo),
                'sufijo': new FormControl(pal.sufijo),
                'ubicacionantigua':new FormControl(''),
                'posicionantigua': new FormControl(''),
                'existe':new FormControl(false),
                'guia': new FormControl('')
              });
              (<FormArray>that.signupFormMov2.get('pallets')).push(control);

              if(indice == that.pallets2.length){
                that.alert = 'Existen busquedas sin resultados.';
                that.isopen = true;
                that._loaddata.loadChange(100);
              }
            }
          },
          (error) => {
            that.showError(error.error.error);
          }
        );
      }
    }, 100);
  }

  onSelectedLocationPallet(pos:number){
    this.alert = 'Buscando posiciones vacias '+(<FormArray>this.signupFormMov2.get('pallets')).controls[pos].value.ubicacion+'.';
    this.isopen = true;
    this._loaddata.loadChange(40);

    this._locationService.freePositionsFromLocation((<FormArray>this.signupFormMov2.get('pallets')).controls[pos].value.idubicacion).subscribe(
      (response:any) => {
        //console.log("SELECTED LOCATION PALLET", response);
        this._loaddata.loadChange(80);

        let ubicacion = '';
        let idubicacion = (<FormArray>this.signupFormMov2.get('pallets')).controls[pos].value.idubicacion;
        for(let ubi of this.locaciones){
          if(parseInt(idubicacion) == parseInt(ubi.id)){
            ubicacion = ubi.attributes.name;
            break;
          }
        }

        if(idubicacion == 9 || idubicacion == 10){
          (<FormArray>this.signupFormMov2.get('pallets')).controls[pos].patchValue({
            'idubicacion':(<FormArray>this.signupFormMov2.get('pallets')).controls[pos].value.idubicacion,
            'ubicacion':ubicacion,
            'posicion':null,
            'idposicion':null,
            'guia':null
          });
        }
        else{
          (<FormArray>this.signupFormMov2.get('pallets')).controls[pos].patchValue({
            'idubicacion':(<FormArray>this.signupFormMov2.get('pallets')).controls[pos].value.idubicacion,
            'ubicacion':ubicacion,
            'posicion':null,
            'idposicion':null,
            'guia':' '
          });
        }

        this.positions[pos] = [];
        this.positions[pos] = response.data;
        if(response.data.length == 0){
          this.alert = 'NO existen posiciones disponibles.';
        }
        else{
          this.alert = 'Carga correcta de posiciones.';
        }
        this._loaddata.loadChange(100);
        this.onClosedAutomatic();
      },
      (error) => {
        this.showError(error.error.error);
      }
    )
  }

  onCheckPalletExiste(){
    let salida = true;
    for(let pallet of (<FormArray>this.signupFormMov2.get('pallets')).controls){
      if(pallet.value.existe == false){
        salida = false;
        break;
      }
    }
    return salida;
  }

  onSelectdPositionPallet(pos:number){
    let posis = this.positions[pos];
    let posicion = '';
    let idposicion = (<FormArray>this.signupFormMov2.get('pallets')).controls[pos].value.idposicion;

    for(let pos of posis){
      if(parseInt(idposicion) == parseInt(pos.id)){
        posicion = pos.attributes.name;
        break;
      }
    }

    (<FormArray>this.signupFormMov2.get('pallets')).controls[pos].patchValue({
      'idposicion':idposicion,
      'posicion':posicion
    });
  }

  loadCajas(){
    this.trabajando = true;
    this.alert = 'Preparando petición.';
    this.isopen = true;
    this._loaddata.loadChange(20);
    let that=this;
    let indice = 1;

    while((<FormArray>that.signupFormMov3.get('cajas')).controls.length > 0){
      (<FormArray>that.signupFormMov3.get('cajas')).removeAt((<FormArray>that.signupFormMov3.get('cajas')).controls.length - 1);
    }
    this.signupFormMov3.reset();
    this.palletubicados = [];
    this.palletsnuevos = [];

    that.signupFormMov3b.reset();
    that.signupFormMov3b.patchValue({
      'idubicacion': null,
      'idpallet': null,
      'idposicion':null,
      'ubicacion':null,
      'pallet':null,
      'posicion':null,
      'guia':''
    });

    setTimeout(function(){
      that.alert = 'Cargando pallet vacios.';
      //SE cargan los pallets sin ubicacion y vacios.
      that._palletsService.getNewPallets().subscribe((response:any) => {
        that.palletsnuevos = response.data;
        that.alert = 'Empezando busqueda de cajas.';
        for(let pal of that.cajas2){
          that.alert = 'Buscando caja '+pal.prefijo+'-'+pal.sufijo;
          that._stockService.getOneStock(pal.prefijo,pal.sufijo).subscribe(
            (response:any) => {
              //console.log("respuesta caja ", response);
              let generic = response.relationships.tag.data.relationships.production_order.data.attributes.is_generic
              let op_generic = response.relationships.tag.data.relationships.production_order.data.attributes.number.indexOf("-0000");
              if(generic == 1 && op_generic == 2){
                this.isgeneric_movimiento = true;
              }
              //console.log("ES GENERICA ", this.isgeneric_movimiento);
              let qr = '';
              let pa = response;
              that.alert = 'Caja '+pa.relationships.tag.data.attributes.prefix+'-'+pa.relationships.tag.data.attributes.suffix+' ha sido encontrada.';
              let idubi = '';
              that._loaddata.loadChange(50);

              const control = new FormGroup({
                'id':new FormControl(pa.id,Validators.required),
                'prefijo':new FormControl(pa.relationships.tag.data.attributes.prefix),
                'sufijo':new FormControl(pa.relationships.tag.data.attributes.suffix),
                'idtag':new FormControl(pa.attributes.tag_id),
                'idpallet':new FormControl(pa.attributes.pallet_id == null ? '' : parseInt(pa.attributes.pallet_id)),
                'idubicacion':new FormControl(parseInt(pa.relationships.position.data.relationships.location.data.id),Validators.required),
                'idposicion':new FormControl(pa.relationships.position.data == null ? '': parseInt(pa.relationships.position.data.id)),
                'pallet':new FormControl(pa.relationships.pallet.data == null ? '' : pa.relationships.pallet.data.attributes.number),
                'op':new FormControl(pa.relationships.tag.data.relationships.production_order.data.attributes.number),
                'ubicacion':new FormControl(pa.relationships.position.data.relationships.location.data.attributes.name),
                'posicion':new FormControl(pa.relationships.position.data == null ? '':pa.relationships.position.data.attributes.name),
                'status':new FormControl(pa.attributes.stock_status_id),
                'cantidad':new FormControl(pa.relationships.pallet.data == null ? '' : pa.relationships.pallet.data.attributes.amount),
                'antiguapallet':new FormControl(pa.relationships.pallet.data == null ? '' : pa.relationships.pallet.data.attributes.number),
                'antiguaubicacion':new FormControl(pa.relationships.position.data.relationships.location.data.attributes.name),
                'antiguaposicion':new FormControl(pa.relationships.position.data == null ? '':pa.relationships.position.data.attributes.name),
                'unidad':new FormControl('cajas'),
                'existe':new FormControl(true),
                'guia':new FormControl('')
              });
              (<FormArray>that.signupFormMov3.get('cajas')).push(control);

              that.alert = "Busqueda terminada satisfactoriamente.";

              if(indice == that.cajas2.length){
                for(let caja of (<FormArray>that.signupFormMov3.get('cajas')).controls){
                  if(caja.value.existe == false){
                    that.alert = "No se han encontrado todas las cajas.";
                  }
                  if(caja.value.idubicacion == 9 || caja.value.idubicacion == 10){
                    that.signupFormMov3b.patchValue({
                      'guia':null
                    });
                  }
                }

                that.trabajando = false;
                that.isopen = true;
                that._loaddata.loadChange(100);
              }
              else{
                indice += 1;
              }
              setTimeout(()=>{
              that.isopen = false;
            }, 3000);
            },
            (error) => {
              const control = new FormGroup({
                'id':new FormControl(-1),
                'prefijo':new FormControl(pal.prefijo),
                'sufijo':new FormControl(pal.sufijo),
                'idtag':new FormControl(-1),
                'idpallet':new FormControl(-1),
                'idubicacion':new FormControl(-1),
                'idposicion':new FormControl(-1),
                'pallet':new FormControl(-1),
                'op':new FormControl(-1),
                'ubicacion':new FormControl(''),
                'posicion':new FormControl(''),
                'status':new FormControl(''),
                'cantidad':new FormControl(0),
                'antiguapallet':new FormControl(''),
                'antiguaubicacion':new FormControl(''),
                'antiguaposicion':new FormControl(''),
                'unidad':new FormControl('cajas'),
                'existe':new FormControl(false),
                'guia':new FormControl(''),
              });
              (<FormArray>that.signupFormMov3.get('cajas')).push(control);
              that.alert = 'Caja '+pal.prefijo+'-'+pal.sufijo+' no ha sido encontrada.';

              if(indice == that.cajas2.length){
                that.showError(" No se han encontrado todas las cajas.");
                that.trabajando = false;
              }
              else{
                indice += 1;
              }
            }
          );
        }
      },
      (error) => {
        that.showError(error.error.error);
        that.trabajando = false;
      });
    }, 100);
  }

  onCheckBoxExiste(){
    let salida = true;
    for(let caja of (<FormArray>this.signupFormMov3.get('cajas')).controls){
      if(caja.value.existe == false){
        salida = false;
        break;
      }
    }
    return salida;
  }

  onCheckIsGuide(){
    let salida = true;
    let externo = false;

    for(let caja of (<FormArray>this.signupFormMov3.get('cajas')).controls){
      if(caja.value.idubicacion == 9 || caja.value.idubicacion == 10){
        externo = true;
        break;
      }
    }

    if(externo == true){
      if(this.signupFormMov3b.get('guia').value == '' || this.signupFormMov3b.get('guia').value == ' ' || this.signupFormMov3b.get('guia').value == null){
        salida = false;
      }
    }

    return salida;
  }

  onCheckIsGuidePallets(){
    let salida = true;
    let guia = false;

    for(let pallet of (<FormArray>this.signupFormMov2.get('pallets')).controls){

      //condicion anterior
      // if(pallet.value.ubicacionantigua == 'MegaFrio' || pallet.value.ubicacionantigua == 'Omega'){
      //   if(pallet.value.guia == '' || pallet.value.guia == ' ' || pallet.value.guia == null){
      //     guia = true;
      //     break;
      //   }
      // }

      if(pallet.value.idubicacion == 9 || pallet.value.idubicacion == 10|| pallet.value.idubicacion == 11){
        if(pallet.value.guia == '' || pallet.value.guia == ' ' || pallet.value.guia == null){
          guia = true;
          break;
        }
      }
    }

    if(guia == true){
      salida = false;
    }
    //console.log("Salida: ",salida);
    return salida;
  }

  onSelectedLocationCaja(){
    this.alert = 'Generando petición.';
    this.isopen = true;
    this._loaddata.loadChange(20);
    this.palletubicados = [];
    this.op = [];
    this.ispalletnuevo = false;
    let qr = '';
    let guion = 0;
    let prefijo = '';
    let sufijo = '';
    let variable = '';
    let repetido = false;
    let diferencia = 0;

    for(let loc of this.locaciones){
      if(parseInt(loc.id) == this.signupFormMov3b.get('idubicacion').value){
        this.signupFormMov3b.patchValue({
          'ubicacion':loc.attributes.name
        });
        break;
      }
    }


    if(this.signupFormMov3b.get('idubicacion').value == 9 || this.signupFormMov3b.get('idubicacion').value == 10){
      this.signupFormMov3b.patchValue({
        'idposicion':null,
        'posicion':null,
        'idpallet':null,
        'pallet':null,
        'guia':null
      });
    }
    else{
      this.signupFormMov3b.patchValue({
        'idposicion':null,
        'posicion':null,
        'idpallet':null,
        'pallet':null,
        'guia':' '
      });
    }

    this.alert = 'Buscando en '+this.signupFormMov3b.get('ubicacion').value+' posiciones libres.';
    this._locationService.freePositionsFromLocation(this.signupFormMov3b.get('idubicacion').value).subscribe(
      (response:any) => {

        this._loaddata.loadChange(30);
        this.posicionespalletsvacios = response.data;
        this.alert = 'Buscando pallet ubicados en '+this.signupFormMov3b.get('ubicacion').value;
        this._palletsService.getbyLocation(this.signupFormMov3b.get('idubicacion').value).subscribe(
          (response:any) => {
            for(let caja of (<FormArray>this.signupFormMov3.get('cajas')).value){
              if(!(this.op.includes('P'+caja.op))){
                this.op.push('P'+caja.op);
              }
            }

            this._loaddata.loadChange(50);
            //console.log("RESPUESTA A PALLETS: ", response);
            let op_caja = (<FormArray>this.signupFormMov3.get('cajas')).at(0).value.op;
            let n_caja = op_caja.indexOf("-0000");
            //console.log("PRIMERA CAJA: ", op_caja);
            //console.log("PRIMERA CAJA N: ", n_caja);
            /*si n_caja == 2 significa que es una caja genérica*/
            if(n_caja == 2){
              this.isgeneric_movimiento = true;
            }
            else{
              this.isgeneric_movimiento = false;
            }

            for(let pal of response.data){
              let n = parseInt(pal.attributes.prefix.indexOf("-0000"));
              //console.log("NNNN: ", n ,pal.attributes.prefix, this.isgeneric_movimiento);

              if(this.op.includes(pal.attributes.prefix) && pal.attributes.amount > 0 && pal.attributes.amount < 90 && ((90 - parseInt(pal.attributes.amount)) >= (this.cajas2.length))){
                this.palletubicados.push(pal);
              }
              else if(this.isgeneric_movimiento == true && n == 3 && pal.attributes.amount < 90){
                this.palletubicados.push(pal);
                //console.log("Entro pallet antiguo");
              }
            }
            //console.log("PALLETS NUEVOS: ", this.palletsnuevos);
            for(let paln of this.palletsnuevos){
              let n = parseInt(paln.attributes.prefix.indexOf("-0000"));
              //console.log("NNNN: ", n ,paln.attributes.prefix, this.isgeneric_movimiento);
              if(this.op.includes(paln.attributes.prefix)){
                this.palletubicados.push(paln);
              }
              else if(this.isgeneric_movimiento == true && n == 3 && paln.attributes.amount < 90){
                this.palletubicados.push(paln);
                //console.log("Entro pallet nuevo");
              }
            }
            //console.log("PALLETS UBICADOS: ",this.palletubicados);
            this.alert = '';
            this._loaddata.loadChange(70);
            if(this.op.length > 1){
              this.alert = 'Carga terminada. Se han ingresado cajas con diferentes ordenes de producción. ';
            }
            if(this.palletubicados.length == 0){
              this.alert += 'No existen pallets en la ubicación deseada.';
            }
            if(this.alert == ''){
              this.alert = 'Pallets Cargados.';
            }

            this.isopen = true;
            this._loaddata.loadChange(100);
            this.onClosedAutomatic();
          },
          (error) => {
            this.showError(error.error.error);
          }
        );
      },
      (error) => {
        this.showError(error.error.error);
      }
    )
  }

  isFromOutside(){
    let salida = false;
    for (let caja of (<FormArray>this.signupFormMov3.get('cajas')).controls){
      if(caja.value.antiguaubicacion == 'MegaFrio' || caja.value.antiguaubicacion == 'Omega'){
        salida = true;
        break;
      }
    }
    return salida;
  }

  onSelectedPalletCaja(){
    for(let pallet of this.palletubicados){
      if(pallet.id == this.signupFormMov3b.get('idpallet').value){
        if(pallet.relationships.position.data != null){
          this.signupFormMov3b.patchValue({
            'idposicion':parseInt(pallet.relationships.position.data.id),
            'pallet':pallet.attributes.number,
            'posicion':pallet.relationships.position.data.attributes.name
          });
          this.ispalletnuevo = false;
          break;
        }
        else{
          this.signupFormMov3b.patchValue({
            'idposicion':null,
            'pallet':pallet.attributes.number,
            'posicion':null
          });
          this.ispalletnuevo = true;
          break;
        }
      }
    }
  }

  onSelectedPositionCaja(){
    for(let pos of this.posicionespalletsvacios){
      if(parseInt(pos.id) == parseInt(this.signupFormMov3b.get('idposicion').value)){
        this.signupFormMov3b.patchValue({
          'posicion':pos.attributes.name
        });
        break;
      }
    }
  }

  updateCajasReturn(){
    let that = this;
    setTimeout(function(){
      that.signupFormMov3b.reset();
      that.signupFormMov3b.patchValue({
        'idubicacion': parseInt((<FormArray>that.signupFormMov3.get('cajas')).value[0].idubicacion),
        'idpallet': parseInt((<FormArray>that.signupFormMov3.get('cajas')).value[0].idpallet),
        'idposicion':parseInt((<FormArray>that.signupFormMov3.get('cajas')).value[0].idposicion),
        'ubicacion':(<FormArray>that.signupFormMov3.get('cajas')).value[0].ubicacion,
        'pallet':(<FormArray>that.signupFormMov3.get('cajas')).value[0].pallet,
        'posicion':(<FormArray>that.signupFormMov3.get('cajas')).value[0].posicion,
        'guia':(<FormArray>that.signupFormMov3.get('cajas')).value[0].guia
      });
    },100);
  }

  updateCajas(){
    for(let caja of (<FormArray>this.signupFormMov3.get('cajas')).controls){
      caja.patchValue({
        'idubicacion': parseInt(this.signupFormMov3b.get('idubicacion').value),
        'idpallet': parseInt(this.signupFormMov3b.get('idpallet').value),
        'idposicion':parseInt(this.signupFormMov3b.get('idposicion').value),
        'ubicacion':this.signupFormMov3b.get('ubicacion').value,
        'pallet':this.signupFormMov3b.get('pallet').value,
        'posicion':this.signupFormMov3b.get('posicion').value,
        'guia':this.signupFormMov3b.get('guia').value
      });
    }
  }

  preSumaryMovPallets(){
    this.trabajando = true;
    this.sumaryMovPallets();
  }

  sumaryMovPallets(){
    this.alert = 'Generando petición.';
    this.isopen = true;
    this.trabajando = true;
    this._loaddata.loadChange(30);

    let cajas = [];
    let idp = 0;
    let idc = 0;

    this.alert = 'Preparando pallets.';
    this._loaddata.loadChange(40);

    for(let pallet of (<FormArray>this.signupFormMov2.get('pallets')).controls){
      this._stockService.getAllStockFromPallet(pallet.value.id).subscribe(
        (response:any) =>{
          cajas = response.data;
          idp += 1;
          //agregar guia
          let prov = this._stockService.transformData9(cajas,pallet);
          this._stockService.updateAll(prov).subscribe(
            response =>{
              this.alert = 'Pallet '+pallet.value.codigo+' se ha movido.';
              if(idp == (<FormArray>this.signupFormMov2.get('pallets')).controls.length){
                this._loaddata.loadChange(70);
                this.confirmMovementPallet();
              }
            },
            (error) => {
              this.alert = error.error.error;
              if(idp == (<FormArray>this.signupFormMov2.get('pallets')).controls.length){
                this.showError(error.error.error);
                this.trabajando = false;
              }
            }
          );
        },
        (error) => {
          this.showError(error.error.error);
          this.trabajando = false;
        }
      );
    }
  }

  preSumaryMovCajas(){
    this.trabajando = true;
    this.sumaryMovCajas();
  }

  //Mueve las cajas
  sumaryMovCajas(){
    this.alert = 'Generando petición.';
    this.isopen = true;
    this.trabajando = true;
    this._loaddata.loadChange(30);

    this.alert = 'Preparando cajas.';
    this._loaddata.loadChange(40);
    let prov = this._stockService.transformData8((<FormArray>this.signupFormMov3.get('cajas')).controls,this.posicionesvacias);

    this._stockService.updateAll(prov).subscribe(
      response =>{
        this.alert = 'Cajas han sido movidas satisfactoriamente.';
        this._loaddata.loadChange(70);
        this.confirmMovementBox();
      },
      (error) => {
        this.showError(error.error.error);
        this.trabajando = false;
      }
    );
  }

  confirmMovementPallet(){
    this.trabajando = false;
    this.etapamov = 1;
    this.alert = 'Movimiento Completo de Pallets';
    this._loaddata.loadChange(100);
    this.onMovimiento();
    this.onClosedAutomatic();
  }

  confirmMovementBox(){
    this.trabajando = false;
    this.etapamov = 1;
    this.alert = 'Movimiento Completo de Cajas';
    this._loaddata.loadChange(100);
    this.onMovimiento();
    this.onClosedAutomatic();
  }

  onSalida():void{
    this.buscar = false;
    this.entrada = false;
    this.movimiento = false;
    this.salida = true;
    this.cajas3 = [];
    this.pallets3 = [];
    this.comenzarSalida = false;
  }

  onCheckTagSalNew(q):void{
    //let qr = this.signupFormSal0.get('busqueda').value;
    //console.log("QR RECIBIDO TAGSALNEW:",q);
    let qr = q;
    if(qr != null && qr != ''){
      let guion = 0;
      let prefijo = '';
      let sufijo = '';
      let variable = '';
      let pallet = '';
      let cliente = '';
      let fecha = '';
      let lote = '';
      let producto = '';
      let especie = '';
      let cajas = '';
      let antiguo = '';
      let op = '';
      let peso = '';

      if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
        qr = qr.substring(3);
      }

      //comprobando si es un pallet al pistolear entrega el formato P18'0000'112Enter
      //let regexp2 = new RegExp("^P\\d{2}[']\\d{4}['][0-9]{1,4}");
      let regexp2 = new RegExp("^P\\d{2}[-]\\d{4}[-][0-9]{1,4}");
      if(regexp2.test(qr)){
        //console.log("PALLET",qr);
        let separar = qr.split("-");
        qr = `${separar[0]}-${separar[1]}-${separar[2]}-`;
      }

      //Si es Pallet
      let regexp = new RegExp('P\\d{2}-\\d{4}-[0-9]{1,4}-');
      if(regexp.test(qr)){
        for(var char of qr){
          if(char != '-'){
            variable += char
          }
          else if(guion == 0){
            variable += '-';
            guion = 1;
          }
          else if(guion == 1){
            prefijo = variable;
            variable = '';
            guion = 2;
          }
          else if (guion == 2){
            sufijo = variable;
            variable = '';
            guion = 3
          }
        }
        antiguo = variable;

        if(prefijo != '' && sufijo != ''){
          let repetido = false;
          for(let pal of this.pallets3){
            if(pal.prefijo == prefijo && pal.sufijo == sufijo){
              repetido = true;
              break;
            }
          }
          if(repetido == false){
            this.pallets3.push({sufijo:sufijo,prefijo:prefijo,error:false,id:-1,razon:null,cantidad:0,guia:null,ubicacion:null,posicion:null});
          }
        }
      }
      else{
        //Si es Caja
        if(parseInt(qr.charAt(0)) >= 0 &&  parseInt(qr.charAt(0)) <= 9){
        //console.log("entró",qr);
        for (var char of qr) {
          if(char != "-"){
            variable += char;
          }
          else if(guion == 0){
            prefijo = variable;
            variable = '';
            guion = 1;
          }
          else if(guion == 1){
            sufijo = variable;
            variable = '';
            guion = 2;
          }
          else if(guion == 2){
            producto = variable;
            variable = '';
            guion = 3;
          }
          else if(guion == 3){
            fecha = variable;
            variable = '';
            guion = 4;
          }
          else if(guion == 4){
            lote = variable;
            variable = '';
            guion = 5;
          }
          else if(guion == 5){
            guion = 6;
          }
          else if(guion == 6){
            op = variable;
            variable = '';
            guion = 7;
          }
          else if(guion == 7){
            peso = variable;
            variable = '';
            guion = 8;
          }
        }
        //cliente = variable;
        let quitar_enter = variable.split("Enter");
        cliente = quitar_enter[0];
        //console.log("Prefijo: ",prefijo);
        //console.log("sufijo: ",sufijo);

      }

      if(prefijo != '' && sufijo != ''){
        let repetido = false;
        for(let caja of this.cajas3){
          if((caja.prefijo == prefijo) && (caja.sufijo == sufijo)){
            repetido = true;
            break;
          }
        }
        if(repetido == false){
          this.cajas3.push({prefijo:prefijo,sufijo:sufijo,producto:producto,lote:lote,especie:especie,fecha:fecha,cliente:cliente,error:false});
        }

        //console.log("cajas actuales: ",this.cajas3);
      }
    }

      this.signupFormSal0.reset();
      this.signupFormSal0.patchValue({
        'busqueda': '',
      });
    }
  }

  onCheckTagSal(e):void{
    let qr = this.signupFormSal0.get('busqueda').value;
    if(qr != null && qr != ''){
      let guion = 0;
      let prefijo = '';
      let sufijo = '';
      let variable = '';
      let pallet = '';
      let cliente = '';
      let fecha = '';
      let lote = '';
      let producto = '';
      let especie = '';
      let cajas = '';
      let antiguo = '';
      let op = '';
      let peso = '';

      if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
        qr = qr.substring(3);
      }

      //Si es Pallet
      let regexp = new RegExp('P\\d{2}-\\d{4}-[0-9]{1,4}-');
      if(regexp.test(qr)){
        for(var char of qr){
          if(char != '-'){
            variable += char
          }
          else if(guion == 0){
            variable += '-';
            guion = 1;
          }
          else if(guion == 1){
            prefijo = variable;
            variable = '';
            guion = 2;
          }
          else if (guion == 2){
            sufijo = variable;
            variable = '';
            guion = 3
          }
        }
        antiguo = variable;

        if(prefijo != '' && sufijo != ''){
          let repetido = false;
          for(let pal of this.pallets3){
            if(pal.prefijo == prefijo && pal.sufijo == sufijo){
              repetido = true;
              break;
            }
          }
          if(repetido == false){
            this.pallets3.push({sufijo:sufijo,prefijo:prefijo,error:false,id:-1,razon:null,cantidad:0,guia:null,ubicacion:null,posicion:null});
          }
        }
      }
      else{
        //Si es Caja
        if(parseInt(qr.charAt(0)) >= 0 &&  parseInt(qr.charAt(0)) <= 9){
        for (var char of qr) {
          if(char != '-'){
            variable += char;
          }
          else if(guion == 0){
            prefijo = variable;
            variable = '';
            guion = 1;
          }
          else if(guion == 1){
            sufijo = variable;
            variable = '';
            guion = 2;
          }
          else if(guion == 2){
            producto = variable;
            variable = '';
            guion = 3;
          }
          else if(guion == 3){
            fecha = variable;
            variable = '';
            guion = 4;
          }
          else if(guion == 4){
            lote = variable;
            variable = '';
            guion = 5;
          }
          else if(guion == 5){
            guion = 6;
          }
          else if(guion == 6){
            op = variable;
            variable = '';
            guion = 7;
          }
          else if(guion == 7){
            peso = variable;
            variable = '';
            guion = 8;
          }
        }
        cliente = variable;
      }

      if(prefijo != '' && sufijo != ''){
        let repetido = false;
        for(let caja of this.cajas3){
          if((caja.prefijo == prefijo) && (caja.sufijo == sufijo)){
            repetido = true;
            break;
          }
        }
        if(repetido == false){
          this.cajas3.push({prefijo:prefijo,sufijo:sufijo,producto:producto,lote:lote,especie:especie,fecha:fecha,cliente:cliente,error:false});
        }
      }
    }

      this.signupFormSal0.reset();
      this.signupFormSal0.patchValue({
        'busqueda': '',
      });
    }
  }

  //Solo para input de prueba
  onCheckTagSal2(e):void{
    let qr = this.signupFormSal0.get('busqueda').value;
    let guion = 0;
    let prefijo = '';
    let sufijo = '';
    let variable = '';
    let pallet = '';
    let cliente = '';
    let fecha = '';
    let lote = '';
    let producto = '';
    let especie = '';
    let cajas = '';
    let antiguo = '';
    let op = '';
    let peso = '';

    if(qr.charAt(0) == '[' && qr.charAt(1) == 'i' && qr.charAt(2) == '¡'){
      qr = qr.substring(3);
    }

    //Si es Pallet
    if(qr.charAt(0) == 'P'){
    for(var char of qr){
      if(char != '-'){
        variable += char
      }
      else if(guion == 0){
        variable += '-';
        guion = 1;
      }
      else if(guion == 1){
        prefijo = variable;
        variable = '';
        guion = 2;
      }
      else if (guion == 2){
        sufijo = variable;
        variable = '';
        guion = 3
      }
    }
    antiguo = variable;

    if(prefijo != '' && sufijo != ''){
      let repetido = false;
      for(let pal of this.pallets3){
        if(pal.prefijo == prefijo && pal.sufijo == sufijo){
          repetido = true;
          break;
        }
      }
      if(repetido == false){
        this.pallets3.push({sufijo:sufijo,prefijo:prefijo,error:false,id:-1,razon:null,cantidad:0,guia:null,ubicacion:null,posicion:null});
      }
    }
  }
  else{
    //Si es Caja
    if(parseInt(qr.charAt(0)) >= 0 &&  parseInt(qr.charAt(0)) <= 9){
    for (var char of qr) {
      if(char != '-'){
        variable += char;
      }
      else if(guion == 0){
        prefijo = variable;
        variable = '';
        guion = 1;
      }
      else if(guion == 1){
        sufijo = variable;
        variable = '';
        guion = 2;
      }
      else if(guion == 2){
        producto = variable;
        variable = '';
        guion = 3;
      }
      else if(guion == 3){
        fecha = variable;
        variable = '';
        guion = 4;
      }
      else if(guion == 4){
        lote = variable;
        variable = '';
        guion = 5;
      }
      else if(guion == 5){
        guion = 6;
      }
      else if(guion == 6){
        op = variable;
        variable = '';
        guion = 7;
      }
      else if(guion == 7){
        peso = variable;
        variable = '';
        guion = 8;
      }
    }
    cliente = variable;
  }

  if(prefijo != '' && sufijo != ''){
    let repetido = false;
    for(let caja of this.cajas3){
      if((caja.prefijo == prefijo) && (caja.sufijo == sufijo)){
        repetido = true;
        break;
      }
    }
    if(repetido == false){
      this.cajas3.push({prefijo:prefijo,sufijo:sufijo,producto:producto,lote:lote,especie:especie,fecha:fecha,cliente:cliente,error:false});
    }
  }
}

this.signupFormSal0.reset();
this.signupFormSal0.patchValue({
  'busqueda': '',
});
}

  reverseEntradaSal(etapasal:number){
    if(etapasal == 2){
      this.prepareSal(2);
      this.etapasal = 1;
    }
    else if(etapasal == 3){
      this.etapasal = 2;
      this.boxes_not_found = [];
      this.pallets_not_found = [];
    }
    else if(etapasal == 4){
      this.etapasal = 3;
    }
  }

  forwardEntradaSal(etapasal:number){
    if(etapasal == 1){
      this.etapasal = 2;
    }
    else if(etapasal == 2){
      this.etapasal = 3;
    }
    else if(etapasal == 3){
      this.etapasal = 4;
    }
  }

  deleteCajaSal(pos:number):void{
    this.cajas3.splice(pos,1);
  }

  deletePalletSal(pos:number):void{
    this.pallets3.splice(pos,1);
  }

  prepareSal(op){
    let nombre = '';
    if(op == 1){
      for(let sal of this.salidas){
        if(parseInt(sal.id) == parseInt(this.signupFormSal1.get('idsalida').value)){
          nombre = sal.name;

          if(sal.id == 8 || sal.id == 9){
            this.signupFormSal1.patchValue({
              'nombresalida': nombre,
              'guiadespacho':'',
              'guia':'',
              'cliente':''
            });
          }
          else{
            this.signupFormSal1.patchValue({
              'nombresalida': nombre,
              'guiadespacho':'No Corresponde',
              'guia':'',
              'cliente':''
            });
          }

          break;
        }
      }
    }
    else{
      this.signupFormSal1.patchValue({
        'idsalida':'',
        'nombresalida': nombre,
        'guia':'',
        'cliente':''
      });
    }
  }

/*realiza la búsqueda de los pallets que se quieren eliminar en caso de que existan pallets Pistoleados
en el arreglo de pallets*/
confirmDeletePallet(){
  this.alert = 'Cargando información.';
  this.isopen = true;
  this.trabajando = true;
  this._loaddata.loadChange(30);

  let idp = 0;
  this.cajasaeliminar = [];

  /*Trae los id de los pallet*/
  if(this.pallets3.length > 0){
    for(let pal of this.pallets3){
      idp += 1;
      this._palletsService.getOne(pal.prefijo,pal.sufijo).subscribe(
        (response:any) => {
          //console.log('pallet one',response);
          if(response.data.length > 0){
            if(this.signupFormSal1.get('guiadespacho').value != 'No Corresponde'){
              pal.guia = parseInt(this.signupFormSal1.get('guiadespacho').value);
            }
            else{
              pal.guia = 'No Corresponde';
            }
            pal.cantidad = parseInt(response.data[0].attributes.amount);
            pal.id = parseInt(response.data[0].id);
            if(response.data[0].relationships.position.data.attributes.name != null && response.data[0].relationships.position.data.attributes.name != undefined && response.data[0].relationships.position.data.attributes.name != ''){
              pal.posicion = response.data[0].relationships.position.data.attributes.name;
            }
            else{
              pal.posicion = 'Sin posición';
            }
            pal.ubicacion = response.data[0].relationships.position.data.attributes.location;
            pal.razon = parseInt(this.signupFormSal1.get('idsalida').value);

            if(idp == this.pallets3.length){
              this.loadBoxestoDelete();
            }
          }
          else{
            this.alert = 'No existe pallet'+pal.prefijo+'-'+pal.sufijo;
            pal.error = true;
            if(idp == this.pallets3.length){
              this.loadBoxestoDelete();
            }
          }
        },
        (error) => {
          if(error.error.code == 404){
            this.pallets_not_found.push({'qr':`${pal.prefijo}-${pal.sufijo}`});
          }
          this.alert = error.error.error;
          pal.error = true;
          if(idp == this.pallets3.length){
            this.loadBoxestoDelete();
          }
        }
      );
    }
  }
  else{
    this.loadBoxestoDelete();
  }
}

/*realiza la búsqueda de las cajas que se quieren eliminar*/
loadBoxestoDelete(){
  this._loaddata.loadChange(50);
  this.alert = 'Cargando datos de cajas individuales.';
  this.isopen = true;
  let idc = 0;
  let that = this;

  if(this.cajas3.length > 0){
    for(let caja of this.cajas3){
      idc += 1;
      this._stockService.getOneStock(caja.prefijo,caja.sufijo).subscribe(
        (response:any) => {
          let encontrado = false;

          /*No ingresar la caja si ya esta en un pallet que se pistoleó*/
          for(let pallet of this.pallets3){
            if(pallet.id == response.attributes.pallet_id){
              encontrado = true;
              break;
            }
          }

          /*No ingresar si ya fue ingresado anteriormente*/
          for(let caj of this.cajasaeliminar){
            if(caj.id == response.id){
              encontrado = true;
              break;
            }
          }

          if(encontrado == false){
              this.cajasaeliminar.push({'prefijo':parseInt(caja.prefijo),'sufijo':parseInt(caja.sufijo),'id':parseInt(response.id),'id_tag':parseInt(response.attributes.tag_id),'id_pallet':parseInt(response.attributes.pallet_id)})
          }

          if(idc == this.cajas3.length){
            this.alert = 'Carga terminada.';
            this._loaddata.loadChange(100);
            this.trabajando = false;
            this.forwardEntradaSal(2);
          }
        },
        (error) => {

          if(error.error.code == 404){
            this.boxes_not_found.push({'qr':`${caja.prefijo}-${caja.sufijo}`});
          }

          if(idc == this.cajas3.length){
            this.showError('Carga terminada.');
            this.trabajando = false;
            this.forwardEntradaSal(2);
          }
          // this.alert = error.error.error
          caja.error = true;
          // if(idc == this.cajas3.length){
          //   this.showError('Carga terminada con errores.');
          //   this.trabajando = false;
          //   this.forwardEntradaSal(2);
          // }
        }
      );
    }
  }
  else{
    this.alert = 'Carga terminada.';
    this._loaddata.loadChange(100);
    this.trabajando = false;
    this.forwardEntradaSal(2);
  }
}

isProblem():boolean{
  let test = false;
  for(let pal of this.pallets3){
    if(pal.error == true){
      test = true;
      break;
    }
  }

  for(let caj of this.cajas3){
    if(caj.error == true){
      test = true;
      break;
    }
  }

  return !(test);
}

/**
 * Se eliminan las cajas y/o pallets
 */
sumarySal(){
  this.alert = 'Generando petición.';
  this.isopen = true;
  this._loaddata.loadChange(40);
  this.trabajando = true;
  let guia = null;
  let cliente = null;
  if(this.signupFormSal1.get('guiadespacho').value != 'No Corresponde'){
    guia = this.signupFormSal1.get('guiadespacho').value;
  }
  if(this.signupFormSal1.get('cliente').value != ""){
    cliente = this.signupFormSal1.get('cliente').value;
  }

  if(this.cajasaeliminar.length > 0){
    // if(this.signupFormSal1.get('guiadespacho').value != 'No Corresponde'){
    //   guia = this.signupFormSal1.get('guiadespacho').value;
    // }
    // if(this.signupFormSal1.get('cliente').value != null){
    //   cliente = this.signupFormSal1.get('cliente').value;
    // }

    this.alert = 'Eliminando cajas.';
    let prov = this._stockService.transformData10(this.cajasaeliminar,this.signupFormSal1.get('idsalida').value,guia,cliente);
    //console.log('eliminando cajas, body->',prov);
    this._stockService.deleteAll(prov).subscribe(
      (response:any) =>{
        //console.log('respuesta eliminacion cajas',response);
        this.alert = 'Cajas eliminadas.';
        this._loaddata.loadChange(70);

        if(this.pallets3.length != 0){
          this.alert += ' .Eliminando Pallets.'
          let prov3 = this._stockService.transformData11(this.pallets3,cliente);
          //console.log('body pallets despues de eliminar cajas',prov3);
          this._stockService.deleteAllStockFromPallet(prov3).subscribe(
            (response:any) => {
              this.alert = 'Pallets eliminados.';
              this.trabajando = false;
              this.etapasal = 1;
              this._loaddata.loadChange(100);
              this.onSalida();
              this.prepareSal(2);
              this.limpiarDatosSalida();
            },
            (error:any) => {
              this.trabajando = false;
              this.showError(error.error.error);
              this.limpiarDatosSalida();
            }
          )
        }
        else{
          this.trabajando = false;
          this.etapasal = 1;
          this._loaddata.loadChange(100);
          this.onSalida();
          this.prepareSal(2);
          this.limpiarDatosSalida();
        }
      },
      (error) => {
        //console.log('error eliminacion cajas',error);
        this.trabajando = false;
        this.showError(error.error.error);
        this.limpiarDatosSalida();
      }
    );
  }
  else{
    this.alert = 'Eliminando Pallets.'
    let prov3 = this._stockService.transformData11(this.pallets3,cliente);
    //console.log('pallets3 ',this.pallets3);
    //console.log('eliminando pallets, body ->',prov3);
    this._stockService.deleteAllStockFromPallet(prov3).subscribe(
      (response:any) => {
        this.alert = 'Pallets eliminados.';
        this.trabajando = false;
        this.etapasal = 1;
        this._loaddata.loadChange(100);
        this.onSalida();
        this.prepareSal(2);
        this.limpiarDatosSalida();
      },
      (error:any) => {
        this.trabajando = false;
        this.showError(error.error.error);
        this.limpiarDatosSalida();
      }
    )
  }
}
/*restablece los campos que se utilizan en la salida*/
limpiarDatosSalida(){
  this.pallets3 = [];
  this.cajas3 = [];
  this.cajasaeliminar = [];
}

  /**
  * Cierra el modal
  */
  hideChildModal(): void {
    this.lgModal.hide();
  }

  /**
  * Cierra el mensaje de alerta.
  */
  onClosed(): void {
    this.isopen = false;
  }

  /**
  * Cierra el mensaje de alerta despues de 3 segundos
  */
  onClosedAutomatic(): void {

      setTimeout(()=>{
      this.isopen = false;
    }, 3000);

  }

  /**
  * Muestra un error
  * @param  msg mensaje del error
  */
  showError(msg:string){
    if(msg == undefined){
      this.alert = 'No tiene permisos para realizar la acción.';
    }
    else{
      this.alert = msg;
    }
    this._loaddata.loadChange(100);
    this.isopen =true;
  }

  /**
  * Actualiza el listado por la paginacion
  * @param data nuevo listado o mensaje de error.
  */
  updateData(data:any):void{
    if(data === "Error al cargar listado."){
      this.showError(data);
    }
    else{
      this.data_list = data;
    }
  }


  openModalComentario(grupo_cajas:any, template: TemplateRef<any> ){
    //console.log("Comentarios", grupo_cajas);
    //let comentarios = `primer comentario, segundo comentario, tercer comentario, cuarto comentario, quinto comentario, sexto comentario`;
    if(grupo_cajas.comentarios!= null){
      let arrayComentarios = grupo_cajas.comentarios.split(',');
      for(let c of arrayComentarios){
        this.comentarios.push(c);
      }
    }
    else{
      this.comentarios = ['primer comentario','segundocomentario','tercer comentario'];
    }

    this.modalRef = this.modalService.show(template);
  }

  cerrarModalComentarios(){
    this.comentarios = [];
    this.modalRef.hide();
  }

  comenzarPistoleo(){
    this.comenzarSalida = true;
    //this.onCheckTagSalNew('P18-0000-7-');

    //codigos donde se hicieron pruebas en salidas de cajas y pallets
    // this.onCheckTagSalNew('P18-0000-18-');
    // this.onCheckTagSalNew('P18-0000-18-');
    // this.onCheckTagSalNew('103027-1-');
    // this.onCheckTagSalNew('8281-1-');
    // this.onCheckTagSalNew('8281-2-');
    // this.onCheckTagSalNew('8281-3-');
    // this.onCheckTagSalNew('8281-4-');
    // this.onCheckTagSalNew('8281-5-');
    // this.onCheckTagSalNew('8281-6-');
    // this.onCheckTagSalNew('8281-7-');

    // this.onCheckTagSalNew('103028-1-');
    // this.onCheckTagSalNew('103028-2-');
    // this.onCheckTagSalNew('103028-3-');

    // this.onCheckTagSalNew('104220-1-');
    // this.onCheckTagSalNew('104220-2-');//eliminado por reempaque
    // this.onCheckTagSalNew('104220-3-');//eliminado por reempaque
    // this.onCheckTagSalNew('104220-4-');
    // this.onCheckTagSalNew('104220-5-');

    // this.onCheckTagSalNew('104487-1-');//venta nacional guia 765 Japofish
    // this.onCheckTagSalNew('104487-2-');//venta nacional guia 765 Japofish
    // this.onCheckTagSalNew('104487-3-');//venta nacional guia 765 Japofish

    // this.onCheckTagSalNew('104920-1-');//analisis muestra
    // this.onCheckTagSalNew('104920-2-');//analisis muestra
     //this.onCheckTagSalNew('104920-3-');//venta internacional guia 205 Mexicofish

     //pallet
     //this.onCheckTagSalNew('P18-0000-33-');
     //this.onCheckTagSalNew('P18-0000-5-');//korea venta internacional guia 225
     //this.onCheckTagSalNew('P18-0000-19-');//union saldo
  }
}



// WEBPACK FOOTER //
// C:/Apache24/htdocs/ostimar/frontend/src/app/components/movimientos/movimientos.component.ts